import React, { useState, useRef, useEffect, Fragment, useMemo  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AdminSubdevisionService from "../../../API/Services/AdminService/AdminSubdevisionService";
import SubdivisionOffcanvas from "../../pages/WeeklyData/SubdivisionOffcanvas";
import MainPagetitle from "../../layouts/MainPagetitle";
import { Offcanvas, Form, Col } from "react-bootstrap";
import AdminBuilderService from "../../../API/Services/AdminService/AdminBuilderService";
import Button from "react-bootstrap/Button";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ClipLoader from "react-spinners/ClipLoader";
import DateComponent from "../../components/date/DateFormat";
import AccessField from "../../components/AccssFieldComponent/AccessFiled";
import Modal from "react-bootstrap/Modal";
import PriceComponent from "../../components/Price/PriceComponent";
import { Row } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import BulkSubdivisionUpdate from "./BulkSubdivisionUpdate";
import ColumnReOrderPopup from "../../popup/ColumnReOrderPopup";
import { Link } from 'react-router-dom';
import { MultiSelect } from "react-multi-select-component";
import DatePicker from "react-datepicker";
import axios from "axios";
import './subdivisionList.css';
import Swal from "sweetalert2";
import { Tooltip } from "react-tooltip";
import { IoMdInformationCircleOutline } from "react-icons/io";
import "react-tooltip/dist/react-tooltip.css";
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const SubdivisionList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = JSON.parse(queryParams.get("page")) === 1 ? null : JSON.parse(queryParams.get("page"));

  const SyestemUserRole = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).role : "";
  const [allSubdivisionExport, setAllSubdivisionExport] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [updateStatisticsLoading, setUpdateStatisticsLoading] = useState(false);
  const [excelDownload, setExcelDownload] = useState(false);

  const addToSubdivisionList = () => {
    navigate('/google-map-locator', {
      state: {
        subdivisionList: allSubdivisionExport,
        subdivision: true
      },
    });
  };

  const [selectedLandSales, setSelectedLandSales] = useState([]);

  const handleEditCheckboxChange = (e, userId) => {
    if (e.target.checked) {
      setSelectedLandSales((prevSelectedUsers) => [...prevSelectedUsers, userId]);
    } else {
      setSelectedLandSales((prevSelectedUsers) => prevSelectedUsers.filter((id) => id !== userId));
    }
  };

  const [Error, setError] = useState("");
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState(localStorage.getItem("searchQueryBySubdivisionFilter_Subdivision") ? JSON.parse(localStorage.getItem("searchQueryBySubdivisionFilter_Subdivision")) : "");
  const [subdivisionList, setSubdivisionList] = useState([]);
  const [subdivisionListCount, setSubdivisionListCount] = useState('');

  const [exportmodelshow, setExportModelShow] = useState(false)
  const [selectAll, setSelectAll] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const resetSelection = () => {
    setSelectAll(false);
    setSelectedColumns([]);
  };

  const [pageChange, setPageChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 100;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [npage, setNpage] = useState(0);
  const number = [...Array(Math.max(0, npage) + 1).keys()].slice(1);

  const [filter, setFilter] = useState(false);
  const [normalFilter, setNormalFilter] = useState(false);

  const [filterQuery, setFilterQuery] = useState({
    status: localStorage.getItem("subdivision_status_Subdivision") ? JSON.parse(localStorage.getItem("subdivision_status_Subdivision")) : "",
    reporting: localStorage.getItem("reporting_Subdivision") ? JSON.parse(localStorage.getItem("reporting_Subdivision")) : "",
    name: localStorage.getItem("subdivision_name_Subdivision") ? JSON.parse(localStorage.getItem("subdivision_name_Subdivision")) : "",
    builder_name: localStorage.getItem("builder_name_Subdivision") ? JSON.parse(localStorage.getItem("builder_name_Subdivision")) : "",
    product_type: localStorage.getItem("product_type_Subdivision") ? JSON.parse(localStorage.getItem("product_type_Subdivision")) : "",
    area: localStorage.getItem("area_Subdivision") ? JSON.parse(localStorage.getItem("area_Subdivision")) : "",
    masterplan_id: localStorage.getItem("masterplan_id_Subdivision") ? JSON.parse(localStorage.getItem("masterplan_id_Subdivision")) : "",
    zipcode: localStorage.getItem("zipcode_Subdivision") ? JSON.parse(localStorage.getItem("zipcode_Subdivision")) : "",
    lotwidth: localStorage.getItem("lotwidth_Subdivision") ? JSON.parse(localStorage.getItem("lotwidth_Subdivision")) : "",
    lotsize: localStorage.getItem("lotsize_Subdivision") ? JSON.parse(localStorage.getItem("lotsize_Subdivision")) : "",
    age: localStorage.getItem("age_Subdivision") ? JSON.parse(localStorage.getItem("age_Subdivision")) : "",
    single: localStorage.getItem("single_Subdivision") ? JSON.parse(localStorage.getItem("single_Subdivision")) : "",
    gated: localStorage.getItem("gated_Subdivision") ? JSON.parse(localStorage.getItem("gated_Subdivision")) : "",
    juridiction: localStorage.getItem("juridiction_Subdivision") ? JSON.parse(localStorage.getItem("juridiction_Subdivision")) : "",
    gasprovider: localStorage.getItem("gasprovider_Subdivision") ? JSON.parse(localStorage.getItem("gasprovider_Subdivision")) : "",
    from: localStorage.getItem("from_Subdivision") ? JSON.parse(localStorage.getItem("from_Subdivision")) : "",
    to: localStorage.getItem("to_Subdivision") ? JSON.parse(localStorage.getItem("to_Subdivision")) : "",
  });

  const getLocalStorageValue = (key, defaultValue = "") => {
    const value = localStorage.getItem(key);

    if (
      value === null ||
      value === undefined ||
      value === "undefined" ||
      value === "null" ||
      value === ""
    ) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return defaultValue;
    }
  };

  const [filterQueryCalculation, setFilterQueryCalculation] = useState({
    months_open: getLocalStorageValue("months_open_Subdivision"),
    latest_lots_released: getLocalStorageValue("latest_lots_released_Subdivision"),
    latest_standing_inventory: getLocalStorageValue("latest_standing_inventory_Subdivision"),
    avg_sqft_all: getLocalStorageValue("avg_sqft_all_Subdivision"),
    avg_sqft_active: getLocalStorageValue("avg_sqft_active_Subdivision"),
    avg_base_price_all: getLocalStorageValue("avg_base_price_all_Subdivision"),
    avg_base_price_active: getLocalStorageValue("avg_base_price_active_Subdivision"),
    min_sqft_all: getLocalStorageValue("min_sqft_all_Subdivision"),
    min_sqft_active: getLocalStorageValue("min_sqft_active_Subdivision"),
    max_sqft_all: getLocalStorageValue("max_sqft_all_Subdivision"),
    max_sqft_active: getLocalStorageValue("max_sqft_active_Subdivision"),
    min_base_price_all: getLocalStorageValue("min_base_price_all_Subdivision"),
    min_sqft_active_current: getLocalStorageValue("min_sqft_active_current_Subdivision"),
    max_base_price_all: getLocalStorageValue("max_base_price_all_Subdivision"),
    
    min_base_price_active: getLocalStorageValue("min_base_price_active_Subdivision"),
    max_base_price_active: getLocalStorageValue("max_base_price_active_Subdivision"),

    max_sqft_active_current: getLocalStorageValue("max_sqft_active_current_Subdivision"),
    avg_net_traffic_per_month_this_year: getLocalStorageValue("avg_net_traffic_per_month_this_year_Subdivision"),
    avg_net_sales_per_month_this_year: getLocalStorageValue("avg_net_sales_per_month_this_year_Subdivision"),
    avg_closings_per_month_this_year: getLocalStorageValue("avg_closings_per_month_this_year_Subdivision"),
    avg_net_sales_per_month_since_open: getLocalStorageValue("avg_net_sales_per_month_since_open_Subdivision"),
    avg_net_sales_per_month_last_three_months: getLocalStorageValue("avg_net_sales_per_month_last_three_months_Subdivision"),
    month_net_sold: getLocalStorageValue("month_net_sold_Subdivision"),
    year_net_sold: getLocalStorageValue("year_net_sold_Subdivision"),
  });

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const [manageAccessOffcanvas, setManageAccessOffcanvas] = useState(false);
  const [manageFilterOffcanvas, setManageFilterOffcanvas] = useState(false);

  const [accessList, setAccessList] = useState({});
  const [accessRole, setAccessRole] = useState("Admin");
  const [accessForm, setAccessForm] = useState({});
  const [role, setRole] = useState("Admin");
  const [checkedItems, setCheckedItems] = useState({});
  const [manageAccessField, setManageAccessField] = useState(false);
  const [fieldList, setFieldList] = useState([]);
  // const fieldList = AccessField({ tableName: "subdivisions" });

  const [openDialog, setOpenDialog] = useState(false);
  const [columns, setColumns] = useState([]);
  console.log("columns:", columns);
  
  const [draggedColumns, setDraggedColumns] = useState(columns);

  const [calculationData, setCalculationData] = useState({});
  const [handleCallBack, setHandleCallBack] = useState(false);
  const [canvasShowAdd, seCanvasShowAdd] = useState(false);
  const [canvasShowEdit, seCanvasShowEdit] = useState(false);

  const [totalLotsOption, setTotalLotsOption] = useState("");
  const [lotWidthOption, setLotWidthOption] = useState("");
  const [lotSizeOption, setLotSizeOption] = useState("");
  const [masterPlanFeeOption, setMasterPlanFeeOption] = useState("");
  const [hOAFeeOption, setHOAFeeOption] = useState("");
  const [totalClosingsOption, setTotalClosingsOption] = useState("");
  const [totalPermitsOption, setTotalPermitsOption] = useState("");
  const [totalNetSalesOption, setTotalNetSalesOption] = useState("");
  const [monthsOpenOption, setMonthsOpenOption] = useState("");
  const [latestLotsReleasedOption, setLatestLotsReleasedOption] = useState("");
  const [latestStandingInventoryOption, setLatestStandingInventoryOption] = useState("");
  const [unsoldLotsOption, setUnsoldLotsOption] = useState("");
  const [avgSqftAllOption, setAvgSqftAllOption] = useState("");
  const [avgSqftActiveOption, setAvgSqftActiveOption] = useState("");
  const [avgBasePriceAllOption, setAvgBasePriceAllOption] = useState("");
  const [avgBasePriceActiveOption, setAvgBasePriceActiveOption] = useState("");
  const [minSqftAllOption, setMinSqftAllOption] = useState("");
  const [maxSqftAllOption, setMaxSqftAllOption] = useState("");
  const [minBasePriceAllOption, setMinBasePriceAllOption] = useState("");
  const [minSqftActiveOption, setMinSqftActiveOption] = useState("");
  const [maxBasePriceAllOption, setMaxBasePriceAllOption] = useState("");
  const [maxSqftActiveOption, setMaxSqftActiveOption] = useState("");
  const [avgNetTrafficPerMonthThisYearOption, setAvgNetTrafficPerMonthThisYearOption] = useState("");
  const [avgNetSalesPerMonthThisYearOption, setAvgNetSalesPerMonthThisYearOption] = useState("");
  const [avgClosingsPerMonthThisYearOption, setAvgClosingsPerMonthThisYearOption] = useState("");
  const [avgNetSalesPerMonthSinceOpenOption, setAvgNetSalesPerMonthSinceOpenOption] = useState("");
  const [avgNetSalesPerMonthLastThreeMonthsOption, setAvgNetSalesPerMonthLastThreeMonthsOption] = useState("");
  const [monthNetSoldOption, setMonthNetSoldOption] = useState("");
  const [yearNetSoldOption, setYearNetSoldOption] = useState("");
  const [avgClosingPriceOption, setAvgClosingPriceOption] = useState("");
  const [permitsThisYearOption, setPermitsThisYearOption] = useState("");
  const [medianClosingPriceSinceOpenOption, setMedianClosingPriceSinceOpenOption] = useState("");
  const [medianClosingPriceThisYearOption, setMedianClosingPriceThisYearOption] = useState("");

  const [totalLotsResult, setTotalLotsResult] = useState(0);
  const [lotWidthResult, setLotWidthResult] = useState(0);
  const [lotSizeResult, setLotSizeResult] = useState(0);
  const [hOAFeeResult, setHOAFeeResult] = useState(0);
  const [masterPlanFeeResult, setmasterPlanFeeResult] = useState(0);
  const [totalClosingsResult, setTotalClosingsResult] = useState(0);
  const [totalPermitsResult, setTotalPermitsResult] = useState(0);
  const [totalNetSalesResult, setTotalNetSalesResult] = useState(0);
  const [monthsOpenResult, setMonthsOpenResult] = useState(0);
  const [latestLotsReleasedResult, setLatestLotsReleasedResult] = useState(0);
  const [latestStandingInventoryResult, setLatestStandingInventoryResult] = useState(0);
  const [unsoldLotsResult, setUnsoldLotsResult] = useState(0);
  const [avgSqftAllResult, setAvgSqftAllResult] = useState(0);
  const [avgSqftActiveResult, setAvgSqftActiveResult] = useState(0);
  const [avgBasePriceAllResult, setAvgBasePriceAllResult] = useState(0);
  const [avgBasePriceActiveResult, setAvgBasePriceActiveResult] = useState(0);
  const [minSqftAllResult, setMinSqftAllResult] = useState(0);
  const [maxSqftAllResult, setMaxSqftAllResult] = useState(0);
  const [minBasePriceAllResult, setMinBasePriceAllResult] = useState(0);
  const [minSqftActiveResult, setMinSqftActiveResult] = useState(0);
  const [maxBasePriceAllResult, setMaxBasePriceAllResult] = useState(0);
  const [maxSqftActiveResult, setMaxSqftActiveResult] = useState(0);
  const [avgNetTrafficPerMonthThisYearResult, setAvgNetTrafficPerMonthThisYearResult] = useState(0);
  const [avgNetSalesPerMonthThisYearResult, setAvgNetSalesPerMonthThisYearResult] = useState(0);
  const [avgClosingsPerMonthThisYearResult, setAvgClosingsPerMonthThisYearResult] = useState(0);
  const [avgNetSalesPerMonthSinceOpenResult, setAvgNetSalesPerMonthSinceOpenResult] = useState(0);
  const [avgNetSalesPerMonthLastThreeMonthsResult, setAvgNetSalesPerMonthLastThreeMonthsResult] = useState(0);
  const [monthNetSoldResult, setMonthNetSoldResult] = useState(0);
  const [yearNetSoldResult, setYearNetSoldResult] = useState(0);
  const [avgClosingPriceResult, setAvgClosingPriceResult] = useState(0);
  const [permitsThisYearResult, setPermitsThisYearResult] = useState(0);
  const [medianClosingPriceSinceOpenResult, setMedianClosingPriceSinceOpenResult] = useState(0);
  const [medianClosingPriceThisYearResult, setMedianClosingPriceThisYearResult] = useState(0);

  const [selectedBuilderName, setSelectedBuilderName] = useState([]);
  const [selectedSubdivisionName, setSelectedSubdivisionName] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedReporting, setSelectedReporting] = useState([]);
  const [selectedAge, setSelectedAge] = useState([]);
  const [selectedSingle, setSelectedSingle] = useState([]);
  const [selectedGated, setSelectedGated] = useState([]);
  const [productTypeStatus, setProductTypeStatus] = useState([]);
  const [selectedBuilderIDByFilter, setSelectedBuilderIDByFilter] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedZipCode, setSelectedZipCode] = useState([]);
  const [selectedMasterPlan, setSelectedMasterPlan] = useState([]);
  const [selectedJurisdicition, setSelectedJurisdiction] = useState([]);
  const [seletctedGasProvider, setSelectedGasProvider] = useState([]);

  const handleSortingPopupClose = () => setShowSortingPopup(false);
  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fieldOptions, setFieldOptions] = useState([]);

  // Generate Report
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];
  const startDate = formattedToday;
  const endDate = formattedToday;
  const [loadingReportId, setLoadingReportId] = useState(null);

  const headers = [
    { label: 'Status', key: 'is_active' },
    { label: 'Reporting', key: 'reporting' },
    { label: 'Builder', key: 'builder_name' },
    { label: 'Name', key: 'name' },
    { label: 'Product Type', key: 'product_type' },
    { label: 'Area', key: 'area' },
    { label: 'Master Plan', key: 'masteplan_id' },
    { label: 'ZIP Code', key: 'zipcode' },
    { label: 'Total Lots', key: 'totallots' },
    { label: 'Lot Width', key: 'lotwidth' },
    { label: 'Lot Size', key: 'lotsize' },
    { label: 'Zoning', key: 'zoning' },
    { label: 'Age Restricted', key: 'age' },
    { label: 'All Single Story', key: 'single' },
    { label: 'Gated', key: 'gated' },
    { label: 'Cross Streets', key: 'crossstreet' },
    { label: 'Jurisdiction', key: 'juridiction' },
    { label: 'Latitude', key: 'lat' },
    { label: 'Longitude', key: 'lng' },
    { label: 'Gas Provider', key: 'gasprovider' },
    { label: 'HOA Fee', key: 'hoafee' },
    { label: 'Master Plan Fee', key: 'masterplanfee' },
    { label: 'Parcel Group', key: 'parcel' },
    { label: 'Phone', key: 'phone' },
    { label: 'Website', key: 'website' },
    { label: 'FK Builder Id', key: 'builder_code' },
    { label: 'Total Closings', key: 'total_closings' },
    { label: 'Total Permits', key: 'total_permits' },
    { label: 'Total Net Sales', key: 'total_net_sales' },
    { label: 'Months Open', key: 'months_open' },
    { label: 'Latest Traffic/Sales Data', key: 'latest_traffic_data' },
    { label: 'Latest Lots Released', key: 'latest_lots_released' },
    { label: 'Latest Standing Inventory', key: 'latest_standing_inventory' },
    { label: 'Unsold Lots', key: 'unsold_lots' },
    { label: 'Avg Sqft All', key: 'avg_sqft_all' },
    { label: 'Avg Sqft Active', key: 'avg_sqft_active' },
    { label: 'Avg Base Price All', key: 'avg_base_price_all' },
    { label: 'Avg Base Price Active', key: 'avg_base_price_active' },
    { label: 'Min Sqft All', key: 'min_sqft_all' },
    { label: 'Min Sqft Active', key: 'min_sqft_active' },
    { label: 'Max Sqft All', key: 'max_sqft_all' },
    { label: 'Max Sqft Active', key: 'max_sqft_active' },
    { label: 'Min Base Price All', key: 'min_base_price_all' },
    { label: 'Max Base Price All', key: 'max_base_price_all' },
    { label: 'Max Sqft Active Current', key: 'max_sqft_active_current' },
    { label: 'Avg Traffic Per Month This Year', key: 'avg_net_traffic_per_month_this_year' },
    { label: 'Avg Net Sales Per Month This Year', key: 'avg_net_sales_per_month_this_year' },
    { label: 'Avg Closings Per Month This Year', key: 'avg_closings_per_month_this_year' },
    { label: 'Avg Net Sales Per Month Since Open', key: 'avg_net_sales_per_month_since_open' },
    { label: 'Avg Net Sales Per Month Last 3 Months', key: 'avg_net_sales_per_month_last_three_months' },
    { label: 'Max Week Ending', key: 'max_week_ending' },
    { label: 'Min Week Ending', key: 'min_week_ending' },
    { label: 'Sqft Group', key: 'sqft_group' },
    { label: 'Price Group', key: 'price_group' },
    { label: 'Month Net Sold', key: 'month_net_sold' },
    { label: 'Year Net Sold', key: 'year_net_sold' },
    { label: 'Open Since', key: 'opensince' },
    { label: 'Avg Closing Price', key: 'avg_closing_price' },
    { label: 'Permits This Year', key: 'permit_this_year' },
    { label: 'Median Closing Price Since Open', key: 'median_closing_price_since_open' },
    { label: 'Median Closing Price This Year', key: 'median_closing_price_this_year' },
    { label: 'Date Added', key: 'created_at' },
    { label: 'Date of First Permit', key: 'date_of_first_permit' },
    { label: 'Date of First Closing', key: 'date_of_first_closing' },
    { label: 'Date of Initial Land Purchase', key: 'date_of_initial_land_purchase' },
  ];

  const exportColumns = [
    { label: 'Status', key: 'is_active' },
    { label: 'Reporting', key: 'reporting' },
    { label: 'Builder', key: 'builder_name' },
    { label: 'Name', key: 'name' },
    { label: 'Product Type', key: 'product_type' },
    { label: 'Area', key: 'area' },
    { label: 'Master Plan', key: 'masteplan_id' },
    { label: 'ZIP Code', key: 'zipcode' },
    { label: 'Total Lots', key: 'totallots' },
    { label: 'Lot Width', key: 'lotwidth' },
    { label: 'Lot Size', key: 'lotsize' },
    { label: 'Zoning', key: 'zoning' },
    { label: 'Age Restricted', key: 'age' },
    { label: 'All Single Story', key: 'single' },
    { label: 'Gated', key: 'gated' },
    { label: 'Cross Streets', key: 'crossstreet' },
    { label: 'Jurisdiction', key: 'juridiction' },
    { label: 'Latitude', key: 'lat' },
    { label: 'Longitude', key: 'lng' },
    { label: 'Gas Provider', key: 'gasprovider' },
    { label: 'HOA Fee', key: 'hoafee' },
    { label: 'Master Plan Fee', key: 'masterplanfee' },
    { label: 'Parcel Group', key: 'parcel' },
    { label: 'Phone', key: 'phone' },
    { label: 'Website', key: 'website' },
    { label: 'FK Builder Id', key: 'builder_code' },
    { label: 'Total Closings', key: 'total_closings' },
    { label: 'Total Permits', key: 'total_permits' },
    { label: 'Total Net Sales', key: 'total_net_sales' },
    { label: 'Months Open', key: 'months_open' },
    { label: 'Latest Traffic/Sales Data', key: 'latest_traffic_data' },
    { label: 'Latest Lots Released', key: 'latest_lots_released' },
    { label: 'Latest Standing Inventory', key: 'latest_standing_inventory' },
    { label: 'Unsold Lots', key: 'unsold_lots' },
    { label: 'Avg Sqft All', key: 'avg_sqft_all' },
    { label: 'Avg Sqft Active', key: 'avg_sqft_active' },
    { label: 'Avg Base Price All', key: 'avg_base_price_all' },
    { label: 'Avg Base Price Active', key: 'avg_base_price_active' },
    { label: 'Min Sqft All', key: 'min_sqft_all' },
    { label: 'Min Sqft Active', key: 'min_sqft_active' },
    { label: 'Max Sqft All', key: 'max_sqft_all' },
    { label: 'Max Sqft Active', key: 'max_sqft_active' },
    { label: 'Min Base Price All', key: 'min_base_price_all' },
    { label: 'Max Base Price All', key: 'max_base_price_all' },
    { label: 'Max Sqft Active Current', key: 'max_sqft_active_current' },
    { label: 'Avg Traffic Per Month This Year', key: 'avg_net_traffic_per_month_this_year' },
    { label: 'Avg Net Sales Per Month This Year', key: 'avg_net_sales_per_month_this_year' },
    { label: 'Avg Closings Per Month This Year', key: 'avg_closings_per_month_this_year' },
    { label: 'Avg Net Sales Per Month Since Open', key: 'avg_net_sales_per_month_since_open' },
    { label: 'Avg Net Sales Per Month Last 3 Months', key: 'avg_net_sales_per_month_last_three_months' },
    { label: 'Max Week Ending', key: 'max_week_ending' },
    { label: 'Min Week Ending', key: 'min_week_ending' },
    { label: 'Sqft Group', key: 'sqft_group' },
    { label: 'Price Group', key: 'price_group' },
    { label: 'Month Net Sold', key: 'month_net_sold' },
    { label: 'Year Net Sold', key: 'year_net_sold' },
    { label: 'Open Since', key: 'opensince' },
    { label: 'Avg Closing Price', key: 'avg_closing_price' },
    { label: 'Permits This Year', key: 'permit_this_year' },
    { label: 'Median Closing Price Since Open', key: 'median_closing_price_since_open' },
    { label: 'Median Closing Price This Year', key: 'median_closing_price_this_year' },
    { label: 'Date Added', key: 'created_at' },
    { label: 'Date of First Permit', key: 'date_of_first_permit' },
    { label: 'Date of First Closing', key: 'date_of_first_closing' },
    { label: 'Date of Initial Land Purchase', key: 'date_of_initial_land_purchase' },
  ];

  const handleSelectAllToggle = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      setSelectedColumns(exportColumns.map(col => col.label));
    } else {
      setSelectedColumns([]);
    }
  };

  const handleColumnToggle = (column) => {
    const updatedColumns = selectedColumns.includes(column)
      ? selectedColumns.filter((col) => col !== column)
      : [...selectedColumns, column];
    setSelectedColumns(updatedColumns);
    setSelectAll(updatedColumns.length === exportColumns.length);
  };

  const checkFieldExist = (fieldName) => {
    return fieldList.includes(fieldName.trim());
  };

  const handleDownloadExcel = async () => {
    setExcelDownload(true);

    try {
      const exportPayload = {
        ...buildSubdivisionPayload(currentPage, sortConfig),
        columns: selectedColumns,
      };

      const response = await AdminSubdevisionService.export(exportPayload).blob();

      const downloadUrl = URL.createObjectURL(response);
      const a = document.createElement("a");

      a.href = downloadUrl;
      a.setAttribute("download", "subdivisions.xlsx");
      document.body.appendChild(a);

      setExcelDownload(false);
      setExportModelShow(false);

      swal({
        text: "Download Completed",
      }).then((willDownload) => {
        if (willDownload) {
          a.click();
          a.parentNode.removeChild(a);
          resetSelection();
        }
      });
    } catch (error) {
      setExcelDownload(false);
      setExportModelShow(false);

      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  // const handleDownloadExcel = async () => {
  //   const isAnyFilterApplied = Object.values(filterQueryCalculation).some(query => query !== "");
  //   let sortConfigString = "";
  //   if (sortConfig !== null) {
  //     sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
  //   }

  //   setExcelDownload(true);
  //   // if (isAnyFilterApplied) {
  //   //   let tableHeaders;
  //   //   if (selectedColumns.length > 0) {
  //   //     tableHeaders = selectedColumns;
  //   //   } else {
  //   //     tableHeaders = headers.map((c) => c.label);
  //   //   }
  //   //   const is_calculated = "&is_calculated";
  //   //   const response = await AdminSubdevisionService.export(currentPage, sortConfigString, searchQuery, "", is_calculated).json();
  //   //   if (response.status) {
  //   //     const tableData = subdivisionList?.map((row) => {
  //   //       const mappedRow = {};
  //   //       tableHeaders.forEach((header) => {
  //   //         switch (header) {
  //   //           case "Status":
  //   //             mappedRow[header] = (row.status === 1 && "Active") || (row.status === 0 && "Sold Out") || (row.status === 2 && "Future");
  //   //             break;
  //   //           case "Reporting":
  //   //             mappedRow[header] = (row.reporting === 1 && "Yes") || (row.status === 0 && "No");
  //   //             break;
  //   //           case "Builder":
  //   //             mappedRow[header] = row.builder ? row.builder.name : '';
  //   //             break;
  //   //           case "Name":
  //   //             mappedRow[header] = row.name;
  //   //             break;
  //   //           case "Product Type":
  //   //             mappedRow[header] = row.product_type;
  //   //             break;
  //   //           case "Area":
  //   //             mappedRow[header] = row.area;
  //   //             break;
  //   //           case "Master Plan":
  //   //             mappedRow[header] = row.masterplan_id;
  //   //             break;
  //   //           case "ZIP Code":
  //   //             mappedRow[header] = row.zipcode;
  //   //             break;
  //   //           case "Total Lots":
  //   //             mappedRow[header] = row.totallots;
  //   //             break;
  //   //           case "Lot Width":
  //   //             mappedRow[header] = row.lotwidth;
  //   //             break;
  //   //           case "Lot Size":
  //   //             mappedRow[header] = row.lotsize;
  //   //             break;
  //   //           case "Zoning":
  //   //             mappedRow[header] = row.zoning;
  //   //             break;
  //   //           case "Age Restricted":
  //   //             mappedRow[header] = (row.age === 1 && "Yes") || (row.age === 0 && "No");
  //   //             break;
  //   //           case "All Single Story":
  //   //             mappedRow[header] = (row.single === 1 && "Yes") || (row.single === 0 && "No");
  //   //             break;
  //   //           case "Gated":
  //   //             mappedRow[header] = (row.gated === 1 && "Yes") || (row.gated === 0 && "No");
  //   //             break;
  //   //           case "Cross Streets":
  //   //             mappedRow[header] = row.crossstreet;
  //   //             break;
  //   //           case "Jurisdiction":
  //   //             mappedRow[header] = row.juridiction;
  //   //             break;
  //   //           case "Latitude":
  //   //             mappedRow[header] = row.lat;
  //   //             break;
  //   //           case "Longitude":
  //   //             mappedRow[header] = row.lng;
  //   //             break;
  //   //           case "Gas Provider":
  //   //             mappedRow[header] = row.gasprovider;
  //   //             break;
  //   //           case "HOA Fee":
  //   //             mappedRow[header] = row.hoafee;
  //   //             break;
  //   //           case "Master Plan Fee":
  //   //             mappedRow[header] = row.masterplanfee;
  //   //             break;
  //   //           case "Parcel Group":
  //   //             mappedRow[header] = row.parcel;
  //   //             break;
  //   //           case "Phone":
  //   //             mappedRow[header] = row.phone;
  //   //             break;
  //   //           case "Website":
  //   //             mappedRow[header] = row.website ? row.website : '';
  //   //             break;
  //   //           case "Date Added":
  //   //             mappedRow[header] = row.dateadded;
  //   //             break;
  //   //           case "FK Builder Id":
  //   //             mappedRow[header] = row.builder ? row.builder.builder_code : '';
  //   //             break;
  //   //           case 'Total Closings':
  //   //             mappedRow[header] = row.total_closings;
  //   //             break;
  //   //           case 'Total Permits':
  //   //             mappedRow[header] = row.total_permits;
  //   //             break;
  //   //           case 'Total Net Sales':
  //   //             mappedRow[header] = row.total_net_sales;
  //   //             break;
  //   //           case 'Months Open':
  //   //             mappedRow[header] = row.months_open;
  //   //             break;
  //   //           case 'Latest Traffic/Sales Data':
  //   //             mappedRow[header] = row.latest_traffic_data;
  //   //             break;
  //   //           case 'Latest Lots Released':
  //   //             mappedRow[header] = row.latest_lots_released;
  //   //             break;
  //   //           case 'Latest Standing Inventory':
  //   //             mappedRow[header] = row.latest_standing_inventory;
  //   //             break;
  //   //           case 'Unsold Lots':
  //   //             mappedRow[header] = row.unsold_lots;
  //   //             break;
  //   //           case 'Avg Sqft All':
  //   //             mappedRow[header] = row.avg_sqft_all;
  //   //             break;
  //   //           case 'Avg Sqft Active':
  //   //             mappedRow[header] = row.avg_sqft_active;
  //   //             break;
  //   //           case 'Avg Base Price All':
  //   //             mappedRow[header] = row.avg_base_price_all;
  //   //             break;
  //   //           case 'Avg Base Price Active':
  //   //             mappedRow[header] = row.avg_base_price_active;
  //   //             break;
  //   //           case 'Min Sqft All':
  //   //             mappedRow[header] = row.min_sqft_all;
  //   //             break;
  //   //           case 'Min Sqft Active':
  //   //             mappedRow[header] = row.min_sqft_active;
  //   //             break;
  //   //           case 'Max Sqft All':
  //   //             mappedRow[header] = row.max_sqft_all;
  //   //             break;
  //   //           case 'Max Sqft Active':
  //   //             mappedRow[header] = row.max_sqft_active;
  //   //             break;
  //   //           case 'Min Base Price All':
  //   //             mappedRow[header] = row.min_base_price_all;
  //   //             break;
  //   //           case 'Min Sqft Active':
  //   //             mappedRow[header] = row.min_sqft_active;
  //   //             break;
  //   //           case 'Max Base Price All':
  //   //             mappedRow[header] = row.max_base_price_all;
  //   //             break;
  //   //           case 'Max Sqft Active Current':
  //   //             mappedRow[header] = row.max_sqft_active;
  //   //             break;
  //   //           case 'Avg Traffic Per Month This Year':
  //   //             mappedRow[header] = row.avg_net_traffic_per_month_this_year;
  //   //             break;
  //   //           case 'Avg Net Sales Per Month This Year':
  //   //             mappedRow[header] = row.avg_net_sales_per_month_this_year;
  //   //             break;
  //   //           case 'Avg Closings Per Month This Year':
  //   //             mappedRow[header] = row.avg_closings_per_month_this_year;
  //   //             break;
  //   //           case 'Avg Net Sales Per Month Since Open':
  //   //             mappedRow[header] = row.avg_net_sales_per_month_since_open;
  //   //             break;
  //   //           case 'Avg Net Sales Per Month Last 3 Months':
  //   //             mappedRow[header] = row.avg_net_sales_per_month_last_three_months;
  //   //             break;
  //   //           case 'Max Week Ending':
  //   //             mappedRow[header] = row.max_week_ending;
  //   //             break;
  //   //           case 'Min Week Ending':
  //   //             mappedRow[header] = row.min_week_ending;
  //   //             break;
  //   //           case 'Sqft Group':
  //   //             mappedRow[header] = row.sqft_group;
  //   //             break;
  //   //           case 'Price Group':
  //   //             mappedRow[header] = row.price_group.group;
  //   //             break;
  //   //           case 'Month Net Sold':
  //   //             mappedRow[header] = row.month_net_sold;
  //   //             break;
  //   //           case 'Year Net Sold':
  //   //             mappedRow[header] = row.year_net_sold;
  //   //             break;
  //   //           case 'Open Since':
  //   //             mappedRow[header] = <DateComponent date={row.opensince} />;
  //   //             break;
  //   //           case 'Avg Closing Price':
  //   //             mappedRow[header] = row.avg_closing_price;
  //   //             break;
  //   //           case 'Permits This Year':
  //   //             mappedRow[header] = row.permit_this_year;
  //   //             break;
  //   //           case 'Median Closing Price Since Open':
  //   //             mappedRow[header] = row.median_closing_price_since_open;
  //   //             break;
  //   //           case 'Median Closing Price This Year':
  //   //             mappedRow[header] = row.median_closing_price_this_year;
  //   //             break;
  //   //           default:
  //   //             mappedRow[header] = '';
  //   //         }
  //   //       });
  //   //       return mappedRow;
  //   //     });

  //   //     const workbook = XLSX.utils.book_new();
  //   //     const worksheet = XLSX.utils.json_to_sheet(tableData, { header: tableHeaders });

  //   //     // Optionally apply styles to the headers
  //   //     const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
  //   //     for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
  //   //       const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
  //   //       if (!cell.s) cell.s = {};
  //   //       cell.s.font = { name: 'Calibri', sz: 11, bold: false };
  //   //     }

  //   //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Worksheet');

  //   //     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   //     const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   //     setExportModelShow(false);
  //   //     setExcelDownload(false);
  //   //     swal({
  //   //       text: "Download Completed"
  //   //     }).then((willDelete) => {
  //   //       if (willDelete) {
  //   //         saveAs(data, 'subdivisions.xlsx');
  //   //         resetSelection();
  //   //       }
  //   //     });
  //   //   } else {
  //   //     setExportModelShow(false);
  //   //     setExcelDownload(false);
  //   //     return;
  //   //   }
  //   // } else {
  //     try {
  //       var exportColumn = {
  //         columns: selectedColumns
  //       }
  //       const response = await AdminSubdevisionService.export(currentPage, sortConfigString, searchQuery, exportColumn, "").blob();
  //       const downloadUrl = URL.createObjectURL(response);
  //       const a = document.createElement('a');
  //       a.href = downloadUrl;
  //       a.setAttribute('download', `subdivisions.xlsx`);
  //       document.body.appendChild(a);
  //       setExcelDownload(false);
  //       setExportModelShow(false);
  //       swal({
  //         text: "Download Completed"
  //       }).then((willDelete) => {
  //         if (willDelete) {
  //           a.click();
  //           a.parentNode.removeChild(a);
  //           setSelectedColumns([]);
  //         }
  //       });
  //     } catch (error) {
  //     }
  //   // }
  // };

  const [SubdivisionDetails, setSubdivisionDetails] = useState({
    builder_id: "",
    subdivision_code: "",
    name: "",
    status: "",
    reporting: "",
    product_type: "",
    phone: "",
    opensince: "",
    age: "",
    single: "",
    firstpermitdate: "",
    masterplan_id: "",
    lat: "",
    lng: "",
    area: "",
    juridiction: "",
    zipcode: "",
    parcel: "",
    crossstreet: "",
    totallots: "",
    unsoldlots: "",
    lotreleased: "",
    lotwidth: "",
    stadinginventory: "",
    lotsize: "",
    permits: "",
    netsales: "",
    closing: "",
    monthsopen: "",
    gated: "",
    sqftgroup: "",
    dollargroup: "",
    masterplanfee: "",
    lastweeklydata: "",
    dateadded: "",
    zoning: "",
    gasprovider: "",
  });

  const clearSubdivisionDetails = () => {
    setSubdivisionDetails({
      builder_id: "",
      subdivision_code: "",
      name: "",
      status: "",
      reporting: "",
      product_type: "",
      phone: "",
      opensince: "",
      age: "",
      single: "",
      firstpermitdate: "",
      masterplan_id: "",
      lat: "",
      lng: "",
      area: "",
      juridiction: "",
      zipcode: "",
      parcel: "",
      crossstreet: "",
      totallots: "",
      unsoldlots: "",
      lotreleased: "",
      lotwidth: "",
      stadinginventory: "",
      lotsize: "",
      permits: "",
      netsales: "",
      closing: "",
      monthsopen: "",
      gated: "",
      sqftgroup: "",
      dollargroup: "",
      masterplanfee: "",
      lastweeklydata: "",
      dateadded: "",
      zoning: "",
      gasprovider: "",
    });
  };

  const [builderListDropDown, setBuilderListDropDown] = useState([]);
  const [gasProviderDropDown, setGasProviderDropDown] = useState([]);
  const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
  const [zipCodeDropDown, setZipCodeDropDown] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState(() => {
    const savedSortConfig = localStorage.getItem("sortConfigSubdivisions");
    return savedSortConfig ? JSON.parse(savedSortConfig) : [];
  });
  const [selectedFields, setSelectedFields] = useState(() => {
    const saved = localStorage.getItem("selectedFieldsSubdivisions");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectionOrder, setSelectionOrder] = useState(() => {
    const saved = localStorage.getItem("selectionOrderSubdivisions");
    return saved ? JSON.parse(saved) : {};
  });
  const [sortOrders, setSortOrders] = useState(() => {
    const saved = localStorage.getItem("sortOrdersSubdivisions");
    return saved ? JSON.parse(saved) : {};
  });
  const [subdivisionID, setSubdivisionID] = useState();

  const prePage = () => {
    if (currentPage !== 1) {
      setPageChange(true);
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
    setPageChange(true);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setPageChange(true);
      setCurrentPage(currentPage + 1);
    }
  };

  const subdivision = useRef();
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedFileError, setSelectedFileError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);

  const stringifySortConfig = (sortConfig) => {
    return sortConfig.map((sort) => `${sort.key}:${sort.direction}`).join(",");
  };

  const buildSubdivisionPayload = (
    pageNumber = 1,
    sortConfigData = [],
    customFilterQuery = null,
    customCalculationFilter = null
  ) => {
    const finalFilterQuery = customFilterQuery || filterQuery;
    const finalCalculationFilter = customCalculationFilter || filterQueryCalculation;

    return {
      page: pageNumber,
      sortConfig:
        Array.isArray(sortConfigData) && sortConfigData.length > 0
          ? stringifySortConfig(sortConfigData)
          : "",

      status: finalFilterQuery.status,
      reporting: finalFilterQuery.reporting,
      name: finalFilterQuery.name,
      builder_name: finalFilterQuery.builder_name,
      product_type: finalFilterQuery.product_type,
      area: finalFilterQuery.area,
      masterplan_id: finalFilterQuery.masterplan_id,
      zipcode: finalFilterQuery.zipcode,
      lotwidth: finalFilterQuery.lotwidth,
      lotsize: finalFilterQuery.lotsize,
      age: finalFilterQuery.age,
      single: finalFilterQuery.single,
      gated: finalFilterQuery.gated,
      juridiction: finalFilterQuery.juridiction,
      gasprovider: finalFilterQuery.gasprovider,
      from: finalFilterQuery.from,
      to: finalFilterQuery.to,

      ...finalCalculationFilter,
    };
  };

  const GetSubdivisionList = async (
    pageNumber = 1,
    sortConfigData = [],
    customFilterQuery = null,
    customCalculationFilter = null
  ) => {
    setIsLoading(true);
    setExcelLoading(true);
    setCurrentPage(pageNumber);

    const payload = buildSubdivisionPayload(
      pageNumber,
      sortConfigData,
      customFilterQuery,
      customCalculationFilter
    );

    try {
      const response = await AdminSubdevisionService.index(payload);
      const responseData = await response.json();
      setLoading(false);
      setIsLoading(false);
      setExcelLoading(false);
      setPageChange(false);
      setNpage(Math.ceil(responseData.meta.total / recordsPage));
      setSubdivisionList(responseData.data);
      setSubdivisionListCount(responseData.meta.total);
      setHandleCallBack(true);
      if (responseData.meta.total > 100) {
        if(!pageChange){
          FetchAllPages(payload, responseData.data, responseData.meta.total);
        }
      } else {
        if(!pageChange){
          setAllSubdivisionExport(responseData.data);
        }
      }
    } catch (error) {
      setIsLoading(false);
      setExcelLoading(false);
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (handleCallBack && calculationData) {
      Object.entries(calculationData).forEach(([field, value]) => {
        handleSelectChange(value, field);
      });
    }
  }, [handleCallBack, allSubdivisionExport, subdivisionList]);

  useEffect(() => {
    if (selectedLandSales?.length === 0) {
      setHandleCallBack(false);
    }
  }, [selectedLandSales]);

  useEffect(() => {
    const subID = JSON.parse(localStorage.getItem("subdivision_id"));
    if(subID){
      handleRowClick(subID);
    }
  },[]);

  useEffect(() => {
    if(selectedSubdivisionName?.length === 0){
      setFilterQuery(prevState => ({
        ...prevState,
        name: ""
    }));
    }
  }, [selectedSubdivisionName]);

  useEffect(() => {
    if (selectedFields) {
      localStorage.setItem("selectedFieldsSubdivisions", JSON.stringify(selectedFields));
    }
    if (selectionOrder) {
      localStorage.setItem("selectionOrderSubdivisions", JSON.stringify(selectionOrder));
    }
    if (sortOrders) {
      localStorage.setItem("sortOrdersSubdivisions", JSON.stringify(sortOrders));
    }
  }, [selectedFields, selectionOrder, sortOrders]);

  useEffect(() => {
    if (localStorage.getItem("selectedStatusBySubdivisionFilter_Subdivision")) {
      const selectedStatus = JSON.parse(localStorage.getItem("selectedStatusBySubdivisionFilter_Subdivision"));
      handleSelectStatusChange(selectedStatus);
    }
    if (localStorage.getItem("selectedReportingByFilter_Subdivision")) {
      const selectedReporting = JSON.parse(localStorage.getItem("selectedReportingByFilter_Subdivision"));
      handleSelectReportingChange(selectedReporting);
    }
    if (localStorage.getItem("selectedBuilderNameByFilter_Subdivision")) {
      const selectedBuilderName = JSON.parse(localStorage.getItem("selectedBuilderNameByFilter_Subdivision"));
      handleSelectBuilderNameChange(selectedBuilderName);
    }
    if (localStorage.getItem("selectedSubdivisionNameByFilter_Subdivision")) {
      const selectedSubdivisionName = JSON.parse(localStorage.getItem("selectedSubdivisionNameByFilter_Subdivision"));
      handleSelectSubdivisionNameChange(selectedSubdivisionName);
    }
    if (localStorage.getItem("productTypeStatusByFilter_Subdivision")) {
      const productTypeStatus = JSON.parse(localStorage.getItem("productTypeStatusByFilter_Subdivision"));
      handleSelectProductTypeChange(productTypeStatus);
    }
    if (localStorage.getItem("selectedAreaByFilter_Subdivision")) {
      const selectedArea = JSON.parse(localStorage.getItem("selectedAreaByFilter_Subdivision"));
      handleSelectAreaChange(selectedArea);
    }
    if (localStorage.getItem("selectedZipCodeByFilter_Subdivision")) {
      const selectedZipCode = JSON.parse(localStorage.getItem("selectedZipCodeByFilter_Subdivision"));
      handleSelectZipCodeChange(selectedZipCode);
    }
    if (localStorage.getItem("selectedMasterPlanByFilter_Subdivision")) {
      const selectedMasterPlan = JSON.parse(localStorage.getItem("selectedMasterPlanByFilter_Subdivision"));
      handleSelectMasterPlanChange(selectedMasterPlan);
    }
    if (localStorage.getItem("selectedAgeByFilter_Subdivision")) {
      const selectedAge = JSON.parse(localStorage.getItem("selectedAgeByFilter_Subdivision"));
      handleSelectAgeChange(selectedAge);
    }
    if (localStorage.getItem("selectedSingleByFilter_Subdivision")) {
      const selectedSingle = JSON.parse(localStorage.getItem("selectedSingleByFilter_Subdivision"));
      handleSelectSingleChange(selectedSingle);
    }
    if (localStorage.getItem("selectedGatedByFilter_Subdivision")) {
      const selectedGated = JSON.parse(localStorage.getItem("selectedGatedByFilter_Subdivision"));
      handleSelectGatedChange(selectedGated);
    }
    if (localStorage.getItem("selectedJurisdicitionByFilter_Subdivision")) {
      const selectedJurisdicition = JSON.parse(localStorage.getItem("selectedJurisdicitionByFilter_Subdivision"));
      handleSelectJurisdictionChange(selectedJurisdicition);
    }
    if (localStorage.getItem("seletctedGasProviderByFilter_Subdivision")) {
      const seletctedGasProvider = JSON.parse(localStorage.getItem("seletctedGasProviderByFilter_Subdivision"));
      handleGasProviderChange(seletctedGasProvider);
    }
  }, []);

  useEffect(() => {
    setSearchQuery(filterString());
  }, [filterQuery]);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      if (!manageFilterOffcanvas) {
        if(page === currentPage){
          return;
        } else {
          GetSubdivisionList(page === null ? currentPage : JSON.parse(page), sortConfig);
        }
      }
    } else {
      navigate("/");
    }
  }, [currentPage]);

  // const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  const FetchAllPages = async (basePayload, subdivisionList, subdivisionListCount) => {
    setExcelLoading(true);
    const totalPages = Math.ceil(subdivisionListCount / recordsPage);
    let allData = [...subdivisionList];

    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      if (pageNum === basePayload.page) continue;

      const payload = {
        ...basePayload,
        page: pageNum,
      };

        const pageResponse = await AdminSubdevisionService.index(payload);
        const pageData = await pageResponse.json();
        allData = allData.concat(pageData.data);
      }
      setAllSubdivisionExport(allData);
      setExcelLoading(false);
      setHandleCallBack(true);
    };

  const handleDelete = async (e) => {
    try {
      let responseData = await AdminSubdevisionService.destroy(e).json();
      if (responseData.status === true) {
        GetSubdivisionList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleBulkDelete = async (id) => {
    try {
      let responseData = await AdminSubdevisionService.bulkdestroy(id).json();
      if (responseData.status === true) {
        GetSubdivisionList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const confirmUpdateStatistics = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to update statistics?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then((willUpdate) => {
      if (willUpdate) {
        HandleUpdateStatistics();
      }
    });
  };

  const HandleUpdateStatistics = async () => {
      setUpdateStatisticsLoading(true);
      try {
        let responseData = await AdminSubdevisionService.subdivision_update_statistics().json();
        if (responseData.success === true) {
          setUpdateStatisticsLoading(false);
          swal({
            text: responseData.message,
          }).then((willDelete) => {
            if (willDelete) {
              GetSubdivisionList(currentPage, sortConfig);
            }
          });
        }
      } catch (error) {
        setUpdateStatisticsLoading(false);
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
        }
      }
    };

  const handleCallback = () => {
    GetSubdivisionList(currentPage, sortConfig);
    setSelectedLandSales([]);
  };

  const handleRowClick = async (id) => {
    setShowOffcanvas(true);
    setIsFormLoading(true);
    setSubdivisionID(id);
    try {
      let responseData = await AdminSubdevisionService.show(id).json();
      setSubdivisionDetails(responseData);
      setIsFormLoading(false);
      localStorage.removeItem("subdivision_id");
    } catch (error) {
      if (error.name === "HTTPError") {
        setIsFormLoading(false);
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  useEffect(() => {
    if (manageFilterOffcanvas) {
      GetBuilderDropDownList();
      GetMasterPlanDropDownList();
      GetZipCodeList();
      GetGasProviderDropDownList();
    }
  }, [manageFilterOffcanvas]);

  const GetBuilderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.builderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((builder) => ({
        label: builder.name,
        value: builder.id,
      }));
      setBuilderListDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();

        setError(errorJson.message);
      }
    }
  };

  const GetZipCodeList = async () => {
    try {
      const responseData = await AdminSubdevisionService.get_zipcode_list().json();
      const formattedData = responseData.data.map((zipcode) => ({
        label: zipcode,
        value: zipcode,
      }));
      setZipCodeDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const GetMasterPlanDropDownList = async () => {
    try {
      const response = await AdminBuilderService.masterPlanDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((masterPlan) => ({
        label: masterPlan.label,
        value: masterPlan.value,
      }));
      setMasterPlanDropDownList(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const GetGasProviderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.gasProviderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((gas_provider) => ({
        label: gas_provider.label,
        value: gas_provider.value,
      }));
      setGasProviderDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const [message, setMessage] = useState(false);
    const HandlePopupDetailClick = (e) => {
    setShowPopup(true);
  };
  
  const handlePopupClose = () => setShowPopup(false);

  const setLocalStorageValue = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value ?? ""));
  };

  const HandleFilterForm = (e) => {
    e.preventDefault();

    if (filterQuery.status == "") {
      setShowPopup(true);
      setMessage("Please select status.");

      return;
    }

    const isAnyFilterApplied = Object.values(filterQuery).some(query => query !== "");

    if (!isAnyFilterApplied) {
      localStorage.removeItem("setSubdivisionFilter");
    }
    
    setFilter(false);
    setNormalFilter(false);
    setManageFilterOffcanvas(false);

    GetSubdivisionList(1, sortConfig);
    
    setTotalClosingsOption("");
    setTotalPermitsOption("");
    setTotalNetSalesOption("");
    setMonthsOpenOption("");
    setLatestLotsReleasedOption("");
    setLatestStandingInventoryOption("");
    setUnsoldLotsOption("");
    setAvgSqftAllOption("");
    setAvgSqftActiveOption("");
    setAvgBasePriceAllOption("");
    setAvgBasePriceActiveOption("");
    setMinSqftAllOption("");
    setMaxSqftAllOption("");
    setMinBasePriceAllOption("");
    setMinSqftActiveOption("");
    setMaxBasePriceAllOption("");
    setMaxSqftActiveOption("");
    setAvgNetTrafficPerMonthThisYearOption("");
    setAvgNetSalesPerMonthThisYearOption("");
    setAvgClosingsPerMonthThisYearOption("");
    setAvgNetSalesPerMonthSinceOpenOption("");
    setAvgNetSalesPerMonthLastThreeMonthsOption("");
    setMonthNetSoldOption("");
    setYearNetSoldOption("");
    setTotalClosingsResult(0);
    setTotalPermitsResult(0);
    setTotalNetSalesResult(0);
    setMonthsOpenResult(0);
    setLatestLotsReleasedResult(0);
    setLatestStandingInventoryResult(0);
    setUnsoldLotsResult(0);
    setAvgSqftAllResult(0);
    setAvgSqftActiveResult(0);
    setAvgBasePriceAllResult(0);
    setAvgBasePriceActiveResult(0);
    setMinSqftAllResult(0);
    setMaxSqftAllResult(0);
    setMinBasePriceAllResult(0);
    setMinSqftActiveResult(0);
    setMaxBasePriceAllResult(0);
    setMaxSqftActiveResult(0);
    setAvgNetTrafficPerMonthThisYearResult(0);
    setAvgNetSalesPerMonthThisYearResult(0);
    setAvgClosingsPerMonthThisYearResult(0);
    setAvgNetSalesPerMonthSinceOpenResult(0);
    setAvgNetSalesPerMonthLastThreeMonthsResult(0);
    setMonthNetSoldResult(0);
    setYearNetSoldResult(0);
    localStorage.setItem("selectedStatusBySubdivisionFilter_Subdivision", JSON.stringify(selectedStatus));
    localStorage.setItem("selectedReportingByFilter_Subdivision", JSON.stringify(selectedReporting));
    localStorage.setItem("selectedBuilderNameByFilter_Subdivision", JSON.stringify(selectedBuilderName));
    localStorage.setItem("selectedSubdivisionNameByFilter_Subdivision", JSON.stringify(selectedSubdivisionName));
    localStorage.setItem("productTypeStatusByFilter_Subdivision", JSON.stringify(productTypeStatus));
    localStorage.setItem("selectedAreaByFilter_Subdivision", JSON.stringify(selectedArea));
    localStorage.setItem("selectedZipCodeByFilter_Subdivision", JSON.stringify(selectedZipCode));
    localStorage.setItem("selectedMasterPlanByFilter_Subdivision", JSON.stringify(selectedMasterPlan));
    localStorage.setItem("selectedAgeByFilter_Subdivision", JSON.stringify(selectedAge));
    localStorage.setItem("selectedSingleByFilter_Subdivision", JSON.stringify(selectedSingle));
    localStorage.setItem("selectedGatedByFilter_Subdivision", JSON.stringify(selectedGated));
    localStorage.setItem("selectedJurisdicitionByFilter_Subdivision", JSON.stringify(selectedJurisdicition));
    localStorage.setItem("seletctedGasProviderByFilter_Subdivision", JSON.stringify(seletctedGasProvider));
    localStorage.setItem("subdivision_status_Subdivision", JSON.stringify(filterQuery.status));
    localStorage.setItem("reporting_Subdivision", JSON.stringify(filterQuery.reporting));
    localStorage.setItem("subdivision_name_Subdivision", JSON.stringify(filterQuery.name));
    localStorage.setItem("builder_name_Subdivision", JSON.stringify(filterQuery.builder_name));
    localStorage.setItem("product_type_Subdivision", JSON.stringify(filterQuery.product_type));
    localStorage.setItem("area_Subdivision", JSON.stringify(filterQuery.area));
    localStorage.setItem("masterplan_id_Subdivision", JSON.stringify(filterQuery.masterplan_id));
    localStorage.setItem("zipcode_Subdivision", JSON.stringify(filterQuery.zipcode));
    localStorage.setItem("lotwidth_Subdivision", JSON.stringify(filterQuery.lotwidth));
    localStorage.setItem("lotsize_Subdivision", JSON.stringify(filterQuery.lotsize));
    localStorage.setItem("age_Subdivision", JSON.stringify(filterQuery.age));
    localStorage.setItem("single_Subdivision", JSON.stringify(filterQuery.single));
    localStorage.setItem("gated_Subdivision", JSON.stringify(filterQuery.gated));
    localStorage.setItem("juridiction_Subdivision", JSON.stringify(filterQuery.juridiction));
    localStorage.setItem("gasprovider_Subdivision", JSON.stringify(filterQuery.gasprovider));
    localStorage.setItem("from_Subdivision", JSON.stringify(filterQuery.from));
    localStorage.setItem("to_Subdivision", JSON.stringify(filterQuery.to));

    setLocalStorageValue("months_open_Subdivision", filterQueryCalculation.months_open);
    setLocalStorageValue("latest_lots_released_Subdivision", filterQueryCalculation.latest_lots_released);
    setLocalStorageValue("latest_standing_inventory_Subdivision", filterQueryCalculation.latest_standing_inventory);
    setLocalStorageValue("avg_sqft_all_Subdivision", filterQueryCalculation.avg_sqft_all);
    setLocalStorageValue("avg_sqft_active_Subdivision", filterQueryCalculation.avg_sqft_active);
    setLocalStorageValue("avg_base_price_all_Subdivision", filterQueryCalculation.avg_base_price_all);
    setLocalStorageValue("avg_base_price_active_Subdivision", filterQueryCalculation.avg_base_price_active);
    setLocalStorageValue("min_sqft_all_Subdivision", filterQueryCalculation.min_sqft_all);
    setLocalStorageValue("min_sqft_active_Subdivision", filterQueryCalculation.min_sqft_active);
    setLocalStorageValue("max_sqft_all_Subdivision", filterQueryCalculation.max_sqft_all);
    setLocalStorageValue("max_sqft_active_Subdivision", filterQueryCalculation.max_sqft_active);
    setLocalStorageValue("min_base_price_all_Subdivision", filterQueryCalculation.min_base_price_all);
    setLocalStorageValue("max_base_price_all_Subdivision", filterQueryCalculation.max_base_price_all);

    setLocalStorageValue("min_base_price_active_Subdivision", filterQueryCalculation.min_base_price_active);
    setLocalStorageValue("max_base_price_active_Subdivision", filterQueryCalculation.max_base_price_active);

    setLocalStorageValue("min_sqft_active_current_Subdivision", filterQueryCalculation.min_sqft_active_current);
    setLocalStorageValue("max_sqft_active_current_Subdivision", filterQueryCalculation.max_sqft_active_current);
    setLocalStorageValue("avg_net_traffic_per_month_this_year_Subdivision", filterQueryCalculation.avg_net_traffic_per_month_this_year);
    setLocalStorageValue("avg_net_sales_per_month_this_year_Subdivision", filterQueryCalculation.avg_net_sales_per_month_this_year);
    setLocalStorageValue("avg_closings_per_month_this_year_Subdivision", filterQueryCalculation.avg_closings_per_month_this_year);
    setLocalStorageValue("avg_net_sales_per_month_since_open_Subdivision", filterQueryCalculation.avg_net_sales_per_month_since_open);
    setLocalStorageValue("avg_net_sales_per_month_last_three_months_Subdivision", filterQueryCalculation.avg_net_sales_per_month_last_three_months);
    setLocalStorageValue("month_net_sold_Subdivision", filterQueryCalculation.month_net_sold);
    setLocalStorageValue("year_net_sold_Subdivision", filterQueryCalculation.year_net_sold);

    localStorage.setItem("searchQueryBySubdivisionFilter_Subdivision", JSON.stringify(searchQuery));
  };
 
  const HandleFilter = (e) => {
    const { name, value } = e.target;
    setFilterQuery((prevFilterQuery) => ({
      ...prevFilterQuery,
      [name]: value,
    }));
    setNormalFilter(true);
  };

  const filterString = () => {
    const queryString = Object.keys(filterQuery)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(filterQuery[key])}`
      )
      .join("&");

    return queryString ? `&${queryString}` : "";
  };

  const emptyFilterQuery = {
    status: "",
    reporting: "",
    name: "",
    builder_name: "",
    product_type: "",
    area: "",
    masterplan_id: "",
    zipcode: "",
    lotwidth: "",
    lotsize: "",
    age: "",
    single: "",
    gated: "",
    juridiction: "",
    gasprovider: "",
    from: "",
    to: "",
  };

  const emptyFilterQueryCalculation = {
    months_open: "",
    latest_lots_released: "",
    latest_standing_inventory: "",
    avg_sqft_all: "",
    avg_sqft_active: "",
    avg_base_price_all: "",
    avg_base_price_active: "",
    min_sqft_all: "",
    min_sqft_active: "",
    max_sqft_all: "",
    max_sqft_active: "",
    min_base_price_all: "",
    max_base_price_all: "",
    min_base_price_active: "",
    max_base_price_active: "",
    min_sqft_active_current: "",
    max_sqft_active_current: "",
    avg_net_traffic_per_month_this_year: "",
    avg_net_sales_per_month_this_year: "",
    avg_closings_per_month_this_year: "",
    avg_net_sales_per_month_since_open: "",
    avg_net_sales_per_month_last_three_months: "",
    month_net_sold: "",
    year_net_sold: "",
  };

  const HandleCancelFilter = (e) => {
    if (e) {
      e.preventDefault();
    }

    setFilter(false);
    setNormalFilter(false);
    setManageFilterOffcanvas(false);

    setFilterQuery(emptyFilterQuery);
    setFilterQueryCalculation(emptyFilterQueryCalculation);

    setSearchQuery("");

    setSelectedStatus([]);
    setSelectedReporting([]);
    setSelectedBuilderName([]);
    setSelectedSubdivisionName([]);
    setProductTypeStatus([]);
    setSelectedArea([]);
    setSelectedZipCode([]);
    setSelectedMasterPlan([]);
    setSelectedAge([]);
    setSelectedSingle([]);
    setSelectedGated([]);
    setSelectedJurisdiction([]);
    setSelectedGasProvider([]);
    setSelectedBuilderIDByFilter([]);

    setTotalClosingsOption("");
    setTotalPermitsOption("");
    setTotalNetSalesOption("");
    setMonthsOpenOption("");
    setLatestLotsReleasedOption("");
    setLatestStandingInventoryOption("");
    setUnsoldLotsOption("");
    setAvgSqftAllOption("");
    setAvgSqftActiveOption("");
    setAvgBasePriceAllOption("");
    setAvgBasePriceActiveOption("");
    setMinSqftAllOption("");
    setMaxSqftAllOption("");
    setMinBasePriceAllOption("");
    setMinSqftActiveOption("");
    setMaxBasePriceAllOption("");
    setMaxSqftActiveOption("");
    setAvgNetTrafficPerMonthThisYearOption("");
    setAvgNetSalesPerMonthThisYearOption("");
    setAvgClosingsPerMonthThisYearOption("");
    setAvgNetSalesPerMonthSinceOpenOption("");
    setAvgNetSalesPerMonthLastThreeMonthsOption("");
    setMonthNetSoldOption("");
    setYearNetSoldOption("");

    setTotalClosingsResult(0);
    setTotalPermitsResult(0);
    setTotalNetSalesResult(0);
    setMonthsOpenResult(0);
    setLatestLotsReleasedResult(0);
    setLatestStandingInventoryResult(0);
    setUnsoldLotsResult(0);
    setAvgSqftAllResult(0);
    setAvgSqftActiveResult(0);
    setAvgBasePriceAllResult(0);
    setAvgBasePriceActiveResult(0);
    setMinSqftAllResult(0);
    setMaxSqftAllResult(0);
    setMinBasePriceAllResult(0);
    setMinSqftActiveResult(0);
    setMaxBasePriceAllResult(0);
    setMaxSqftActiveResult(0);
    setAvgNetTrafficPerMonthThisYearResult(0);
    setAvgNetSalesPerMonthThisYearResult(0);
    setAvgClosingsPerMonthThisYearResult(0);
    setAvgNetSalesPerMonthSinceOpenResult(0);
    setAvgNetSalesPerMonthLastThreeMonthsResult(0);
    setMonthNetSoldResult(0);
    setYearNetSoldResult(0);

    const removeKeys = [
      "selectedStatusBySubdivisionFilter_Subdivision",
      "selectedReportingByFilter_Subdivision",
      "selectedBuilderNameByFilter_Subdivision",
      "selectedSubdivisionNameByFilter_Subdivision",
      "productTypeStatusByFilter_Subdivision",
      "selectedAreaByFilter_Subdivision",
      "selectedZipCodeByFilter_Subdivision",
      "selectedMasterPlanByFilter_Subdivision",
      "selectedAgeByFilter_Subdivision",
      "selectedSingleByFilter_Subdivision",
      "selectedGatedByFilter_Subdivision",
      "selectedJurisdicitionByFilter_Subdivision",
      "seletctedGasProviderByFilter_Subdivision",

      "subdivision_status_Subdivision",
      "reporting_Subdivision",
      "subdivision_name_Subdivision",
      "builder_name_Subdivision",
      "product_type_Subdivision",
      "area_Subdivision",
      "masterplan_id_Subdivision",
      "zipcode_Subdivision",
      "lotwidth_Subdivision",
      "lotsize_Subdivision",
      "age_Subdivision",
      "single_Subdivision",
      "gated_Subdivision",
      "juridiction_Subdivision",
      "gasprovider_Subdivision",
      "from_Subdivision",
      "to_Subdivision",

      "months_open_Subdivision",
      "latest_lots_released_Subdivision",
      "latest_standing_inventory_Subdivision",
      "avg_sqft_all_Subdivision",
      "avg_sqft_active_Subdivision",
      "avg_base_price_all_Subdivision",
      "avg_base_price_active_Subdivision",
      "min_sqft_all_Subdivision",
      "min_sqft_active_Subdivision",
      "max_sqft_all_Subdivision",
      "max_sqft_active_Subdivision",
      "min_base_price_all_Subdivision",
      "max_base_price_all_Subdivision",
      "min_base_price_active_Subdivision",
      "max_base_price_active_Subdivision",
      "min_sqft_active_current_Subdivision",
      "max_sqft_active_current_Subdivision",
      "avg_net_traffic_per_month_this_year_Subdivision",
      "avg_net_sales_per_month_this_year_Subdivision",
      "avg_closings_per_month_this_year_Subdivision",
      "avg_net_sales_per_month_since_open_Subdivision",
      "avg_net_sales_per_month_last_three_months_Subdivision",
      "month_net_sold_Subdivision",
      "year_net_sold_Subdivision",

      "searchQueryBySubdivisionFilter_Subdivision",
      "setSubdivisionFilter_Subdivision",
    ];

    removeKeys.forEach((key) => localStorage.removeItem(key));

    GetSubdivisionList(1, sortConfig, emptyFilterQuery, emptyFilterQueryCalculation);
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleProductRedirect = (id, name) => {
    navigate("/filterproducts");
    localStorage.setItem("product_name_Product", JSON.stringify(name));
    localStorage.setItem("product_id", JSON.stringify(id));
    localStorage.setItem("setProductFilter", true);
  };

  const formatDate = (inputDate) => {
    const dateObj = new Date(inputDate);
    return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
  };

  const handlePermitRedirect = (id, date) => {
    const formattedDate = formatDate(date);
    navigate("/filterpermits");
    localStorage.setItem("from_Permit", JSON.stringify(formattedDate));
    localStorage.setItem("to_Permit", JSON.stringify(formattedDate));
    localStorage.setItem("permit_id", JSON.stringify(id));
    localStorage.setItem("setPermitFilter", true);
  };
   const handleTrafficRedirect = (id, date) => {
    const formattedDate = formatDate(date);
    navigate("/filterweeklytrafficandsales");
    localStorage.setItem("from_TrafficSale", JSON.stringify(formattedDate));
    localStorage.setItem("to_TrafficSale", JSON.stringify(formattedDate));
    localStorage.setItem("traffic_id", JSON.stringify(id));
    localStorage.setItem("setTrafficFilter", true);
  };

  const handleClosingRedirect = (id, date) => {
    const formattedDate = formatDate(date);
    navigate("/filterclosings");
    localStorage.setItem("from_Closing", JSON.stringify(formattedDate));
    localStorage.setItem("to_Closing", JSON.stringify(formattedDate));
    localStorage.setItem("closing_id", JSON.stringify(id));
    localStorage.setItem("setClosingFilter", true);
  };

  const handleLandRedirect = (id, date) => {
    const formattedDate = formatDate(date);
    navigate("/filterlandsales");
    localStorage.setItem("from_LandSale", JSON.stringify(formattedDate));
    localStorage.setItem("to_LandSale", JSON.stringify(formattedDate));
    localStorage.setItem("landsale_id", JSON.stringify(id));
    localStorage.setItem("setLansSaleFilter", true);
  };

  // const handleTraficRedirect = () => {
  //   navigate("/trafficsalelist");
  // };

  const HandleRole = (e, role) => {
    if(e) {
      setRole(e.target.value);
      setAccessRole(e.target.value);
    } else {
      setRole(role);
      setAccessRole(role);
    }
  };

  const handleAccessForm = async (e) => {
    e.preventDefault();
    var userData = {
      form: accessForm,
      role: role,
      table: "subdivisions",
    };
    try {
      const data = await AdminSubdevisionService.manageAccessFields(userData).json();
      if (data.status === true) {
        setManageAccessOffcanvas(false);
        setManageAccessField(true);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")));
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(accessList)) {
      const initialCheckedState = {};
      accessList.forEach((element) => {
        initialCheckedState[element.field_name] =
          element.role_name.includes(accessRole);
      });
      setCheckedItems(initialCheckedState);
    }
  }, [accessList, accessRole]);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      const userRole = JSON.parse(localStorage.getItem("user")).role;
      HandleRole("", userRole);
    }
  }, []);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
    setAccessForm((prevAccessForm) => ({
      ...prevAccessForm,
      [name]: checked,
    }));
  };

  const getAccesslist = async () => {
    try {
      const response = await AdminSubdevisionService.accessField();
      const responseData = await response.json();
      setAccessList(responseData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      getAccesslist();
    } else {
      navigate("/");
    }
  }, []);

  const handleFileChange = async (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUploadClick = async () => {
    const file = selectedFile;

    if (file && file.type === "text/csv") {
      setLoading(true);
      setSelectedFileError("");
      setError("");
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = async () => {
        var iFile = fileReader.result;
        setSelectedFile(iFile);
        const inputData = {
          csv: iFile,
        };

        try {
          let responseData = await AdminSubdevisionService.import(inputData).json();
          setSelectedFile("");
          document.getElementById("fileInput").value = null;
          setLoading(false);
          if (responseData.failed_records > 0) {
            let message = [];
            const problematicRows = responseData.failed_records_details.map(detail => detail.row).join(', ');
            const problematicRowsError = responseData.failed_records_details.map(detail => detail.error).join(', ');
            message += '\nRecord Imported: ' + responseData.successful_records;
            message += '\nFailed Record Count: ' + responseData.failed_records;
            message += '\nProblematic Record Rows: ' + problematicRows + '.';
            message += '\nErrors: ' + problematicRowsError + '.';
            message += '\nLast Row: ' + responseData.last_processed_row;
            setShow(false);
            swal({
              title: responseData.message,
              text: message,
            }).then((willDelete) => {
              if (willDelete) {
                GetSubdivisionList(currentPage, sortConfig);
              }
            });
          }  else {
            if (responseData.message) {
              let message = [];
              const updatedRows = responseData.updated_records_details.map(detail => detail.row).join(', ');
              message += '\nUpdated Record Count: ' + responseData.updated_records_count;
              message += '\nUpdated Record Rows: ' + updatedRows + '.';
              setShow(false);
              swal({
                title: responseData.message,
                text: message,
              }).then((willDelete) => {
                if (willDelete) {
                  GetSubdivisionList(currentPage, sortConfig);
                }
              });
            }
          }
        } catch (error) {
          if (error.name === "HTTPError") {
            const errorJson = error.response.json();
            setSelectedFile("");
            setError(errorJson.message);
            document.getElementById("fileInput").value = null;
            setLoading(false);
          }
        }
      };
      setSelectedFileError("");
      setError("");
    } else {
      setSelectedFile("");
      setSelectedFileError("Please select a CSV file.");
    }
  };

  const handlSubdivisionClick = (e) => {
    setShow(true);
  };

  const handleOpenDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(false);
  };

  const handleSaveDialog = () => {
    localStorage.setItem("draggedColumnsSubdivisions", JSON.stringify(draggedColumns));
    setColumns(draggedColumns);
    setOpenDialog(false);
  };

  const handleColumnOrderChange = (result) => {
    if (!result.destination) {
      return;
    }
    const newColumns = Array.from(draggedColumns);
    const [movedColumn] = newColumns.splice(result.source.index, 1);
    newColumns.splice(result.destination.index, 0, movedColumn);
    setDraggedColumns(newColumns);
  };

  useEffect(() => {
    const draggedColumns = JSON.parse(localStorage.getItem("draggedColumnsSubdivisions"));
    if(draggedColumns) {
      setColumns(draggedColumns);
    } else {
      const mappedColumns = fieldList.map((data) => ({
        id: data.charAt(0).toLowerCase() + data.slice(1),
        label: data
      }));
      setColumns(mappedColumns);
    }
  }, [fieldList]);

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join('');
  }

  const applyFilters = () => {
    const isAnyFilterApplied = Object.values(filterQueryCalculation).some(query => query !== "");

    if (allSubdivisionExport.length === 0) {
      setSubdivisionList(subdivisionList)
      return;
    }

    let filtered = allSubdivisionExport;

    const applyNumberFilter = (items, query, key) => {
      if (!query) return items;

      let operator = '=';
      let value = query.trim();

      // 1. Handle empty/null check first
      if (value === '!') {
        return items.filter(item => {
          const val = item[key];
          return val === null || val === '';
        });
      }

      // 2. Handle range (e.g., "209#300")
      if (value.includes('#')) {
        const [min, max] = value.split('#').map(v => parseFloat(v.trim()));
        return items.filter(item => {
          const val = parseFloat(item[key]);
          return !isNaN(val) && val >= min && val <= max;
        });
      }

      // 3. Detect standard comparison operator
      const match = query.match(/^(>=|<=|!=|>|<|=)(.*)$/);
      if (match) {
        operator = match[1];
        value = match[2].trim();
      }

      // 4. Handle AND condition (e.g., "A&B")
      // if (value.includes('&')) {
      //   const values = value.split('&').map(v => v.trim());
      //   return items.filter(item =>
      //     values.includes(String(item[key]))
      //   );
      // }

      // 5. Handle OR condition (e.g., "A|B")
      // if (value.includes('|')) {
      //   const values = value.split('|').map(v => v.trim());
      //   return items.filter(item =>
      //     values.includes(String(item[key]))
      //   );
      // }

      const numberValue = parseFloat(value);
      if (!isNaN(numberValue)) {
        return items.filter(item => {
          const val = parseFloat(item[key]);
          if (isNaN(val)) return false;

          if (operator === '>') return val > numberValue;
          if (operator === '<') return val < numberValue;
          if (operator === '>=') return val >= numberValue;
          if (operator === '<=') return val <= numberValue;
          if (operator === '!=') return val != numberValue;
          if (operator === '=' || operator === '==') return val == numberValue;

          return false;
        });
      }

      return items;
    };

    filtered = applyNumberFilter(filtered, filterQueryCalculation.months_open, 'months_open');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.latest_lots_released, 'latest_lots_released');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.latest_standing_inventory, 'latest_standing_inventory');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_sqft_all, 'avg_sqft_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_sqft_active, 'avg_sqft_active');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_base_price_all, 'avg_base_price_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_base_price_active, 'avg_base_price_active');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.min_sqft_all, 'min_sqft_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.min_sqft_active, 'min_sqft_active');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.max_sqft_all, 'max_sqft_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.max_sqft_active, 'max_sqft_active');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.min_base_price_all, 'min_base_price_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.min_sqft_active_current, 'min_sqft_active_current');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.max_base_price_all, 'max_base_price_all');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.max_sqft_active_current, 'max_sqft_active_current');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_net_traffic_per_month_this_year, 'avg_net_traffic_per_month_this_year');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_net_sales_per_month_this_year, 'avg_net_sales_per_month_this_year');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_closings_per_month_this_year, 'avg_closings_per_month_this_year');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_net_sales_per_month_since_open, 'avg_net_sales_per_month_since_open');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.avg_net_sales_per_month_last_three_months, 'avg_net_sales_per_month_last_three_months');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.month_net_sold, 'month_net_sold');
    filtered = applyNumberFilter(filtered, filterQueryCalculation.year_net_sold, 'year_net_sold');

    if (filterQuery.sqft_group) {
      filtered = filtered.filter((item) =>
        item.sqft_group.toString().includes(filterQuery.sqft_group)
      );
    }
    if (filterQuery.price_group) {
      filtered = filtered.filter((item) =>
        item.price_group.toString().includes(filterQuery.price_group)
      );
    }

    if (isAnyFilterApplied && !normalFilter) {
      setSubdivisionList(filtered.slice(0, 100));
      setSubdivisionListCount(filtered.length);
      setNpage(Math.ceil(filtered.length / recordsPage));
      setNormalFilter(false);
      if(isAnyFilterApplied){
        setFilter(true);
      } else {
        setFilter(false);
      }
    } else {
      setSubdivisionList(filtered.slice(0, 100));
      setSubdivisionListCount(filtered.length);
      setNpage(Math.ceil(filtered.length / recordsPage));
      setCurrentPage(1);
      setNormalFilter(false);
      if(isAnyFilterApplied){
        setFilter(true);
      } else {
        setFilter(false);
      }
    }
  };

  // useEffect(() => {
  //   if (filter) {
  //     applyFilters();
  //   }
  // }, [filterQueryCalculation]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterQueryCalculation(prevFilterQuery => ({
      ...prevFilterQuery,
      [name]: value
    }));
    setFilter(true);
  };

  const totalSumFields = (field) => {
    if (field == "totallots") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.totallots || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.totallots || 0);
        }, 0);
      }
    }
    if (field == "lotwidth") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.lotwidth || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.lotwidth || 0);
        }, 0);
      }
    }
    if (field == "lotsize") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.lotsize || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.lotsize || 0);
        }, 0);
      }
    }
    if (field == "hoafee") {
      const parseHoafee = (value) => {
        if (value != "") {
          let HOAFee = value.replace(/[$,]/g, '');
          return parseFloat(HOAFee) || 0;
        } else {
          return 0;
        }
      };
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + parseHoafee(subdivision.hoafee);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + parseHoafee(subdivision.hoafee);
        }, 0);
      }
    }
    if (field == "masterplanfee") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.masterplanfee || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.masterplanfee || 0);
        }, 0);
      }
    }
    if (field == "total_closings") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.total_closings || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.total_closings || 0);
        }, 0);
      }
    }
    if (field == "total_permits") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.total_permits || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.total_permits || 0);
        }, 0);
      }
    }
    if (field == "total_net_sales") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.total_net_sales || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.total_net_sales || 0);
        }, 0);
      }
    }
    if (field == "months_open") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.months_open || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.months_open || 0);
        }, 0);
      }
    }
    if (field == "latest_lots_released") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.latest_lots_released || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.latest_lots_released || 0);
        }, 0);
      }
    }
    if (field == "latest_standing_inventory") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.latest_standing_inventory || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.latest_standing_inventory || 0);
        }, 0);
      }
    }
    if (field == "unsold_lots") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.unsold_lots || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.unsold_lots || 0);
        }, 0);
      }
    }
    if (field == "avg_sqft_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_sqft_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_sqft_all || 0);
        }, 0);
      }
    }
    if (field == "avg_sqft_active") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_sqft_active || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "avg_base_price_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_base_price_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_base_price_all || 0);
        }, 0);
      }
    }
    if (field == "avg_base_price_active") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_base_price_active || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_base_price_active || 0);
        }, 0);
      }
    }
    if (field == "min_sqft_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.min_sqft_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.min_sqft_all || 0);
        }, 0);
      }
    }
    if (field == "max_sqft_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.max_sqft_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.max_sqft_all || 0);
        }, 0);
      }
    }
    if (field == "min_base_price_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.min_base_price_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.min_base_price_all || 0);
        }, 0);
      }
    }
    if (field == "min_sqft_active") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.min_sqft_active || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.min_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "max_base_price_all") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.max_base_price_all || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.max_base_price_all || 0);
        }, 0);
      }
    }
    if (field == "max_sqft_active") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.max_sqft_active || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.max_sqft_active || 0);
        }, 0);
      }
    }
    if (field == "avg_net_traffic_per_month_this_year") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_traffic_per_month_this_year || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_traffic_per_month_this_year || 0);
        }, 0);
      }
    }
    if (field == "avg_net_sales_per_month_this_year") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_this_year || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_this_year || 0);
        }, 0);
      }
    }
    if (field == "avg_closings_per_month_this_year") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_closings_per_month_this_year || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_closings_per_month_this_year || 0);
        }, 0);
      }
    }
    if (field == "avg_net_sales_per_month_since_open") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_since_open || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_since_open || 0);
        }, 0);
      }
    }
    if (field == "avg_net_sales_per_month_last_three_months") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_last_three_months || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_net_sales_per_month_last_three_months || 0);
        }, 0);
      }
    }
    if (field == "month_net_sold") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.month_net_sold || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.month_net_sold || 0);
        }, 0);
      }
    }
    if (field == "year_net_sold") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.year_net_sold || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.year_net_sold || 0);
        }, 0);
      }
    }
    if (field == "avg_closing_price") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_closing_price || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.avg_closing_price || 0);
        }, 0);
      }
    }
    if (field == "permit_this_year") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.permit_this_year || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.permit_this_year || 0);
        }, 0);
      }
    }
    if (field == "median_closing_price_since_open") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.median_closing_price_since_open || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.median_closing_price_since_open || 0);
        }, 0);
      }
    }
    if (field == "median_closing_price_this_year") {
      if (filter) {
        return subdivisionList.reduce((sum, subdivision) => {
          return sum + (subdivision.median_closing_price_this_year || 0);
        }, 0);
      } else {
        return allSubdivisionExport.reduce((sum, subdivision) => {
          return sum + (subdivision.median_closing_price_this_year || 0);
        }, 0);
      }
    }
  };

  const averageFields = (field) => {
    const sum = totalSumFields(field);
    if (filter) {
      return sum / subdivisionList.length;
    } else {
      return sum / allSubdivisionExport.length;
    }
  };

  const handleSelectChange = (value, field) => {
    setCalculationData((prevData) => ({
      ...prevData,
      [field]: value,  // Store field and value together
    }));

    switch (field) {
      case "totallots":
        setTotalLotsOption(value);

        if (value === 'sum') {
          setTotalLotsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalLotsResult(averageFields(field));
        }
        break;

      case "lotwidth":
        setLotWidthOption(value);

        if (value === 'sum') {
          setLotWidthResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLotWidthResult(averageFields(field));
        }
        break;

      case "lotsize":
        setLotSizeOption(value);

        if (value === 'sum') {
          setLotSizeResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLotSizeResult(averageFields(field));
        }
        break;

      case "hoafee":
        setHOAFeeOption(value);

        if (value === 'sum') {
          setHOAFeeResult(totalSumFields(field));
        } else if (value === 'avg') {
          setHOAFeeResult(averageFields(field));
        }
        break;

      case "masterplanfee":
        setMasterPlanFeeOption(value);

        if (value === 'sum') {
          setmasterPlanFeeResult(totalSumFields(field));
        } else if (value === 'avg') {
          setmasterPlanFeeResult(averageFields(field));
        }
        break;

      case "total_closings":
        setTotalClosingsOption(value);

        if (value === 'sum') {
          setTotalClosingsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalClosingsResult(averageFields(field));
        }
        break;

      case "total_permits":
        setTotalPermitsOption(value);

        if (value === 'sum') {
          setTotalPermitsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalPermitsResult(averageFields(field));
        }
        break;

      case "total_net_sales":
        setTotalNetSalesOption(value);

        if (value === 'sum') {
          setTotalNetSalesResult(totalSumFields(field));
        } else if (value === 'avg') {
          setTotalNetSalesResult(averageFields(field));
        }
        break;

      case "months_open":
        setMonthsOpenOption(value);

        if (value === 'sum') {
          setMonthsOpenResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMonthsOpenResult(averageFields(field));
        }
        break;

      case "latest_lots_released":
        setLatestLotsReleasedOption(value);

        if (value === 'sum') {
          setLatestLotsReleasedResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLatestLotsReleasedResult(averageFields(field));
        }
        break;

      case "latest_standing_inventory":
        setLatestStandingInventoryOption(value);

        if (value === 'sum') {
          setLatestStandingInventoryResult(totalSumFields(field));
        } else if (value === 'avg') {
          setLatestStandingInventoryResult(averageFields(field));
        }
        break;

      case "unsold_lots":
        setUnsoldLotsOption(value);

        if (value === 'sum') {
          setUnsoldLotsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setUnsoldLotsResult(averageFields(field));
        }
        break;

      case "avg_sqft_all":
        setAvgSqftAllOption(value);

        if (value === 'sum') {
          setAvgSqftAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgSqftAllResult(averageFields(field));
        }
        break;

      case "avg_sqft_active":
        setAvgSqftActiveOption(value);

        if (value === 'sum') {
          setAvgSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgSqftActiveResult(averageFields(field));
        }
        break;

      case "avg_base_price_all":
        setAvgBasePriceAllOption(value);

        if (value === 'sum') {
          setAvgBasePriceAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgBasePriceAllResult(averageFields(field));
        }
        break;

      case "avg_base_price_active":
        setAvgBasePriceActiveOption(value);

        if (value === 'sum') {
          setAvgBasePriceActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgBasePriceActiveResult(averageFields(field));
        }
        break;

      case "min_sqft_all":
        setMinSqftAllOption(value);

        if (value === 'sum') {
          setMinSqftAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMinSqftAllResult(averageFields(field));
        }
        break;

      case "max_sqft_all":
        setMaxSqftAllOption(value);

        if (value === 'sum') {
          setMaxSqftAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMaxSqftAllResult(averageFields(field));
        }
        break;

      case "min_base_price_all":
        setMinBasePriceAllOption(value);

        if (value === 'sum') {
          setMinBasePriceAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMinBasePriceAllResult(averageFields(field));
        }
        break;

      case "min_sqft_active":
        setMinSqftActiveOption(value);

        if (value === 'sum') {
          setMinSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMinSqftActiveResult(averageFields(field));
        }
        break;

      case "max_base_price_all":
        setMaxBasePriceAllOption(value);

        if (value === 'sum') {
          setMaxBasePriceAllResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMaxBasePriceAllResult(averageFields(field));
        }
        break;

      case "max_sqft_active":
        setMaxSqftActiveOption(value);

        if (value === 'sum') {
          setMaxSqftActiveResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMaxSqftActiveResult(averageFields(field));
        }
        break;

      case "avg_net_traffic_per_month_this_year":
        setAvgNetTrafficPerMonthThisYearOption(value);

        if (value === 'sum') {
          setAvgNetTrafficPerMonthThisYearResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgNetTrafficPerMonthThisYearResult(averageFields(field));
        }
        break;

      case "avg_net_sales_per_month_this_year":
        setAvgNetSalesPerMonthThisYearOption(value);

        if (value === 'sum') {
          setAvgNetSalesPerMonthThisYearResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgNetSalesPerMonthThisYearResult(averageFields(field));
        }
        break;

      case "avg_closings_per_month_this_year":
        setAvgClosingsPerMonthThisYearOption(value);

        if (value === 'sum') {
          setAvgClosingsPerMonthThisYearResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgClosingsPerMonthThisYearResult(averageFields(field));
        }
        break;

      case "avg_net_sales_per_month_since_open":
        setAvgNetSalesPerMonthSinceOpenOption(value);

        if (value === 'sum') {
          setAvgNetSalesPerMonthSinceOpenResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgNetSalesPerMonthSinceOpenResult(averageFields(field));
        }
        break;

      case "avg_net_sales_per_month_last_three_months":
        setAvgNetSalesPerMonthLastThreeMonthsOption(value);

        if (value === 'sum') {
          setAvgNetSalesPerMonthLastThreeMonthsResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgNetSalesPerMonthLastThreeMonthsResult(averageFields(field));
        }
        break;

      case "month_net_sold":
        setMonthNetSoldOption(value);

        if (value === 'sum') {
          setMonthNetSoldResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMonthNetSoldResult(averageFields(field));
        }
        break;

      case "year_net_sold":
        setYearNetSoldOption(value);

        if (value === 'sum') {
          setYearNetSoldResult(totalSumFields(field));
        } else if (value === 'avg') {
          setYearNetSoldResult(averageFields(field));
        }
        break;

      case "avg_closing_price":
        setAvgClosingPriceOption(value);

        if (value === 'sum') {
          setAvgClosingPriceResult(totalSumFields(field));
        } else if (value === 'avg') {
          setAvgClosingPriceResult(averageFields(field));
        }
        break;

      case "permit_this_year":
        setPermitsThisYearOption(value);

        if (value === 'sum') {
          setPermitsThisYearResult(totalSumFields(field));
        } else if (value === 'avg') {
          setPermitsThisYearResult(averageFields(field));
        }
        break;

      case "median_closing_price_since_open":
        setMedianClosingPriceSinceOpenOption(value);

        if (value === 'sum') {
          setMedianClosingPriceSinceOpenResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMedianClosingPriceSinceOpenResult(averageFields(field));
        }
        break;

      case "median_closing_price_this_year":
        setMedianClosingPriceThisYearOption(value);

        if (value === 'sum') {
          setMedianClosingPriceThisYearResult(totalSumFields(field));
        } else if (value === 'avg') {
          setMedianClosingPriceThisYearResult(averageFields(field));
        }
        break;

      default:
        break;
    }
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "Sold Out" },
    { value: "2", label: "Future" }
  ];

  const reportingOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const ageOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const singleOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const gatedOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" }
  ];

  const productTypeOptions = [
    { value: "DET", label: "DET" },
    { value: "ATT", label: "ATT" },
    { value: "HR", label: "HR" },
    { value: "AC", label: "AC" }
  ];
  const areaOption = [
    { value: "BC", label: "BC" },
    { value: "E", label: "E" },
    { value: "H", label: "H" },
    { value: "IS", label: "IS" },
    { value: "L", label: "L" },
    { value: "MSQ", label: "MSQ" },
    { value: "MV", label: "MV" },
    { value: "NLV", label: "NLV" },
    { value: "NW", label: "NW" },
    { value: "P", label: "P" },
    { value: "SO", label: "SO" },
    { value: "SW", label: "SW" }
  ];

  const handleSelectAreaChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedArea(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      area: selectedValues
    }));
    setNormalFilter(true);
  };

  const handleSelectZipCodeChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedZipCode(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      zipcode: selectedValues
    }));
    setNormalFilter(true);
  };

  const handleSelectMasterPlanChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedMasterPlan(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      masterplan_id: selectedValues
    }));
    setNormalFilter(true);
  };

  const jurisdictionOption = [
    { value: "Boulder City", label: "Boulder City" },
    { value: "CLV", label: "CLV" },
    { value: "CC Enterprise", label: "CC Enterprise" },
    { value: "CC Indian Springs", label: "CC Indian Springs" },
    { value: "CC Laughlin", label: "CC Laughlin" },
    { value: "CC Lone Mtn", label: "CC Lone Mtn" },
    { value: "CC Lower Kyle Canyon", label: "CC Lower Kyle Canyon" },
    { value: "CC Moapa Valley", label: "CC Moapa Valley" },
    { value: "CC Mt Charleston", label: "CC Mt Charleston" },
    { value: "CC Mtn Springs", label: "CC Mtn Springs" },
    { value: "CC Paradise", label: "CC Paradise" },
    { value: "CC Searchlight", label: "CC Searchlight" },
    { value: "CC Spring Valley", label: "CC Spring Valley" },
    { value: "CC Summerlin South", label: "CC Summerlin South" },
    { value: "CC Sunrise Manor", label: "CC Sunrise Manor" },
    { value: "CC Whiteney", label: "CC Whiteney" },
    { value: "CC Winchester", label: "CC Winchester" },
    { value: "CC Unincorporated", label: "CC Unincorporated" },
    { value: "Henderson", label: "Henderson" },
    { value: "Mesquite", label: "Mesquite" },
    { value: "NLV", label: "NLV" },
    { value: "NYE", label: "NYE" },
  ];

  const handleSelectJurisdictionChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedJurisdiction(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      juridiction: selectedValues
    }));
    setNormalFilter(true);
  };

  const gasProviderOption = [
    { value: "SOUTHWEST GAS", label: "SOUTHWEST GAS" },
  ];

  const handleGasProviderChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value).join(', ');
    setSelectedGasProvider(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      gasprovider: selectedValues
    }));
    setNormalFilter(true);
  };

  const handleSelectBuilderNameChange = (selectedItems) => {
    const selectedValues = selectedItems.map(item => item.value);
    const selectedNames = selectedItems.map(item => item.label).join(', ');
    setSelectedBuilderIDByFilter(selectedValues);
    setSelectedBuilderName(selectedItems);
    setSelectedSubdivisionName([]);
    setFilterQuery(prevState => ({
      ...prevState,
      builder_name: selectedNames,
      name: ""
    }));
    setNormalFilter(true);
  };

  const handleSelectSubdivisionNameChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.label).join(', ');
    setSelectedSubdivisionName(selectedItems);
    setFilterQuery(prevState => ({
        ...prevState,
        name: selectedNames
    }));
    setNormalFilter(true);
  };

  const handleSelectStatusChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedStatus(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      status: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectReportingChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedReporting(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      reporting: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectProductTypeChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setProductTypeStatus(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      product_type: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectAgeChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedAge(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      age: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectSingleChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedSingle(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      single: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleSelectGatedChange = (selectedItems) => {
    const selectedNames = selectedItems.map(item => item.value).join(', ');
    setSelectedGated(selectedItems);
    setFilterQuery(prevState => ({
      ...prevState,
      gated: selectedNames
    }));
    setNormalFilter(true);
  }

  const handleFilterDateFrom = (date) => {
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US');

      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        from: formattedDate,
      }));
    } else {
      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        from: '',
      }));
    }
    setNormalFilter(true);
  };

  const handleFilterDateTo = (date) => {
    if (date) {
      const formattedDate = date.toLocaleDateString('en-US');

      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        to: formattedDate,
      }));
    } else {
      setFilterQuery((prevFilterQuery) => ({
        ...prevFilterQuery,
        to: '',
      }));
    }
    setNormalFilter(true);
  };

  const parseDate = (dateString) => {
    const [month, day, year] = dateString.split('/');
    return new Date(year, month - 1, day);
  };

  const handleDownloadReport = async () => {
    if(loadingReportId === subdivisionID){
      return;
    }
    setLoadingReportId(subdivisionID);

    const reportdata = {
      type: "Subdivision Analysis Report",
      start_date: startDate,
      end_date: endDate,
      id: subdivisionID
    };

    const bearerToken = JSON.parse(localStorage.getItem("usertoken"));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_IMAGE_URL}api/admin/report/export-reports`,
        reportdata,
        {
          responseType: "arraybuffer",
          headers: {
            Accept: "application/pdf",
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      setLoadingReportId(null);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      // link.download = `SAR-${startDate}-${endDate}.pdf`;
      link.download = `HBR-subdivision-report.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setLoadingReportId(null);
      if (error.response && error.response.data) {
        setError("Something went wrong");
      }
    }
  };

  useEffect(() => {
  const fieldOptions = fieldList
    .filter((field) => field !== 'Action')
    .map((field) => {
      let value = field.charAt(0).toLowerCase() + field.slice(1).replace(/\s+/g, '');

      if (value === 'builder') {
        value = 'builderName';
      }
      if (value === 'productType') {
        value = 'product_type';
      }
      if (value === 'masterPlan') {
        value = 'masterplan_id';
      }
      if (value === 'zIPCode') {
        value = 'zipcode';
      }
      if (value === 'jurisdiction') {
        value = 'juridiction';
      }
      if (value === 'totalLots') {
        value = 'totallots';
      }
      if (value === 'lotWidth') {
        value = 'lotwidth';
      }
      if (value === 'lotSize') {
        value = 'lotsize';
      }
      if (value === 'ageRestricted') {
        value = 'age';
      }
      if (value === 'allSingleStory') {
        value = 'single';
      }
      if (value === 'crossStreets') {
        value = 'location';
      }
      if (value === 'latitude') {
        value = 'lat';
      }
      if (value === 'longitude') {
        value = 'lng';
      }
      if (value === 'gasProvider') {
        value = 'gasprovider';
      }
      if (value === 'hOAFee') {
        value = 'hoafee';
      }
      if (value === 'masterPlanFee') {
        value = 'masterplanfee';
      }
      if (value === 'parcelGroup') {
        value = 'parcel';
      }
      if (value === 'dateAdded') {
        value = 'dateadded';
      }
      if (value === 'dateofFirstPermit') {
        value = 'date_of_first_permit';
      }
      if (value === 'dateofFirstClosing') {
        value = 'date_of_first_closing';
      }
      if (value === 'dateofInitialLandPurchase') {
        value = 'date_of_initial_land_purchase';
      }
      if (value === '__pkSubID') {
        value = 'subdivision_code';
      }
      if (value === '_fkBuilderID') {
        value = 'builder_code';
      }
      if (value === 'openSince') {
        value = 'opensince';
      }

      return {
        value,
        label: field,
      };
    });

  setFieldOptions(fieldOptions);
}, [fieldList]);

  useEffect(() => {
    if (showPopup) {
      setSelectedFields([]);
      setSortOrders({});
    }
  }, [showPopup]);

  const HandleSortingPopupDetailClick = (e) => {
    setShowSortingPopup(true);
  };

  const handleApplySorting = () => {
    const sortingConfig = selectedFields.map((field) => ({
      key: field.value,
      direction: sortOrders[field.value] || 'asc',
    }));
    localStorage.setItem("sortConfigSubdivisions", JSON.stringify(sortingConfig));
    setSortConfig(sortingConfig);
    GetSubdivisionList(currentPage, sortingConfig);
    handleSortingPopupClose();
  };

  const handleSortingCheckboxChange = (e, field) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedFields([...selectedFields, field]);
      setSelectionOrder((prevOrder) => ({
        ...prevOrder,
        [field.value]: Object.keys(prevOrder).length + 1,
      }));
    } else {
      setSelectedFields(selectedFields.filter((selected) => selected.value !== field.value));
      setSelectionOrder((prevOrder) => {
        const newOrder = { ...prevOrder };
        delete newOrder[field.value];
        const remainingFields = selectedFields.filter((selected) => selected.value !== field.value);
        remainingFields.forEach((field, index) => {
          newOrder[field.value] = index + 1;
        });
        return newOrder;
      });
    }
  };

  const handleSortOrderChange = (fieldValue, order) => {
    setSortOrders({
      ...sortOrders,
      [fieldValue]: order,
    });
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedFields(fieldOptions);
      const newOrder = {};
      fieldOptions.forEach((field, index) => {
        newOrder[field.value] = index + 1;
      });
      setSelectionOrder(newOrder);
    } else {
      setSelectedFields([]);
      setSelectionOrder({});
    }
  };
  const [samePage, setSamePage] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectCheckBox, setSelectCheckBox] = useState(false);

  const handleMainCheckboxChange = (e) => {
    setSamePage(currentPage);
    if (e.target.checked) {
      Swal.fire({
        title: "Select Records",
        html: `
          <div style="text-align: left;">
            <label>
              <input type="radio" name="selection" value="visible" checked />
              Select visible records
            </label>
            <br />
            <label>
              <input type="radio" name="selection" value="all" />
              Select all records
            </label>
          </div>
        `,
        confirmButtonText: "Apply",
        showCancelButton: false,
        preConfirm: () => {
          const selectedOption = document.querySelector('input[name="selection"]:checked').value;
          return selectedOption;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedOption = result.value;
          if (selectedOption === "visible") {
            setIsSelectAll(false);
            setSelectCheckBox(true);
            setSelectedLandSales(subdivisionList.map((user) => user.id));
          } else if (selectedOption === "all") {
            setIsSelectAll(true);
            setSelectCheckBox(true);
            setSelectedLandSales(allSubdivisionExport.map((user) => user.id));
          }
        }
      });
    } else {
      setSelectCheckBox(false);
      setSelectedLandSales([]);
    }
  };

    const getStatusLabel = (status) => {
    const statusMap = {
      0: "Sold Out",
      1: "Active",
      2: "Future",
      3: "Close",
    };

    return statusMap[status] || "Unknown";
  };

const [sortConfigDetail, setSortConfigDetail] = useState({ key: null, direction: "asc" });

const sortedData = useMemo(() => {
  let data = [];

  if (value == 4) {
    data = Array.isArray(SubdivisionDetails.trafic_sales)
      ? SubdivisionDetails.trafic_sales
      : [];
  } else if (value == 2) {
    data = Array.isArray(SubdivisionDetails.products)
      ? SubdivisionDetails.products
      : [];
  } else if (value == 3) {
    data = Array.isArray(SubdivisionDetails.get_permits)
      ? SubdivisionDetails.get_permits
      : [];
  } else if (value == 5) {
    data = Array.isArray(SubdivisionDetails.get_closing)
      ? SubdivisionDetails.get_closing
      : [];
  } else if (value == 6) {
    data = Array.isArray(SubdivisionDetails.land_sales)
      ? SubdivisionDetails.land_sales
      : [];
  } else if (value == 7) {
    data = Array.isArray(SubdivisionDetails.get_parcels)
      ? SubdivisionDetails.get_parcels
      : [];
  }

  return [...data].sort((a, b) => {
  const aVal = a[sortConfigDetail.key]?.toString().toLowerCase() ?? "";
  const bVal = b[sortConfigDetail.key]?.toString().toLowerCase() ?? "";

  const isNumeric = !isNaN(aVal) && !isNaN(bVal);

  if (isNumeric) {
    return sortConfigDetail.direction === "asc"
      ? Number(aVal) - Number(bVal)
      : Number(bVal) - Number(aVal);
  }

  return sortConfigDetail.direction === "asc"
    ? aVal.localeCompare(bVal)
    : bVal.localeCompare(aVal);
});


}, [
  value,
  SubdivisionDetails.trafic_sales,
  SubdivisionDetails.products,
  SubdivisionDetails.get_permits,
  SubdivisionDetails.get_closing,
  SubdivisionDetails.land_sales,
  SubdivisionDetails.get_parcels,
  sortConfigDetail
]);



const requestSort = (key) => {
  let direction = "asc";
  if (sortConfigDetail.key === key && sortConfigDetail.direction === "asc") {
    direction = "desc";
  }
  setSortConfigDetail({ key, direction });
};

const getSortIcon = (key) => {
  if (sortConfigDetail.key !== key) return null;
  return sortConfigDetail.direction === "asc" ? " ▲" : " ▼";
};



  return (
    <Fragment>
      <MainPagetitle
        mainTitle="Subdivision"
        pageTitle="Subdivision"
        parentTitle="Home"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">Subdivision List</h4>
                      <div
                        className=" mx-5"
                        role="group"
                        aria-label="Basic example"
                      >
                      </div>
                      <ColumnReOrderPopup
                        open={openDialog}
                        fieldList={fieldList}
                        handleCloseDialog={handleCloseDialog}
                        handleSaveDialog={handleSaveDialog}
                        draggedColumns={draggedColumns}
                        handleColumnOrderChange={handleColumnOrderChange}
                      />
                    </div>

                    <div className="mt-2" style={{ width: "100%" }}>
                      {(SyestemUserRole == "Admin" || SyestemUserRole == "Staff") ? (
                        <div className="d-flex">
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list"></i>&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort"></i>&nbsp;
                              Sort
                            </div>
                          </Button>
                          <button disabled={excelDownload || subdivisionList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-export" />&nbsp;
                              {excelDownload ? "Downloading..." : "Export"}
                            </div>
                          </button>
                          {/* <Dropdown className="d-inline-block me-1">
                            <Dropdown.Toggle variant="success" className="btn-sm" id="filter-dropdown">
                              <div style={{ fontSize: "11px", display: "inline-block" }}>
                                <i className="fa fa-filter" />&nbsp;
                                Filter
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: '170px', height: 'auto', overflowY: "hidden" }}>
                              <Dropdown.Item onClick={() => setManageFilterOffcanvas(true)}>
                                Filter
                              </Dropdown.Item>

                              {!excelLoading && (
                                <Dropdown.Item onClick={() => setManageCalculationFilterOffcanvas(true)}>
                                  Calculation Filter
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown> */}
                          <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />&nbsp;
                              Filter
                            </div>
                          </button>
                          <Button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => !excelLoading ? addToSubdivisionList() : ""}
                          >
                            {excelLoading ?
                              <div className="spinner-border spinner-border-sm" role="status" />
                              :
                              <div style={{ fontSize: "11px" }}>
                                <i className="fa fa-map-marker" aria-hidden="true" />&nbsp;
                                Map
                              </div>
                            }
                          </Button>
                          <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => setManageAccessOffcanvas(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-shield" />&nbsp;
                              Field Access
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={handlSubdivisionClick}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-import" />&nbsp;
                              Import
                            </div>
                          </Button>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm ms-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => seCanvasShowAdd(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-plus" />&nbsp;
                              Add Subdivision
                            </div>
                          </Link>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm ms-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => selectedLandSales.length > 0 ? seCanvasShowEdit(true) : swal({
                              text: "Please select at least one record.",
                              icon: "warning",
                              dangerMode: true,
                            })}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-pencil" />&nbsp;
                              Edit
                            </div>
                          </Link>
                          <button
                            className="btn btn-danger btn-sm me-1"
                            style={{ marginLeft: "3px" }}
                            onClick={() => selectedLandSales.length > 0 ? swal({
                              title: "Are you sure?",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleBulkDelete(selectedLandSales);
                              }
                            }) : ""}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-trash" />&nbsp;
                              Delete
                            </div>
                          </button>
                          <button
                            className="btn btn-primary btn-sm me-1"
                            disabled={updateStatisticsLoading}
                            onClick={() => confirmUpdateStatistics()}
                            title="Update Statistics"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-chart-line"></i>&nbsp;
                              {updateStatisticsLoading ? "Updating..." : "Update Statistics"}
                            </div>
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list" />&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort" />&nbsp;
                              Sort
                            </div>
                          </Button>
                          {SyestemUserRole != "Tester" &&
                            <button disabled={excelDownload || subdivisionList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                              <div style={{ fontSize: "11px" }}>
                                <i className="fas fa-file-export" />&nbsp;
                                {excelDownload ? "Downloading..." : "Export"}
                              </div>
                            </button>
                          }
                            {/* <Dropdown className="d-inline-block me-1">
                              <Dropdown.Toggle variant="success" className="btn-sm" id="filter-dropdown">
                                <div style={{ fontSize: "11px", display: "inline-block" }}>
                                  <i className="fa fa-filter" />&nbsp;
                                  Filter
                                </div>
                              </Dropdown.Toggle>

                              <Dropdown.Menu style={{ width: '170px', height: 'auto', overflowY: "hidden" }}>
                                <Dropdown.Item onClick={() => setManageFilterOffcanvas(true)}>
                                  Filter
                                </Dropdown.Item>

                                {!excelLoading && (
                                  <Dropdown.Item onClick={() => setManageCalculationFilterOffcanvas(true)}>
                                    Calculation Filter
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown> */}
                            <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                              <div style={{ fontSize: "11px" }}>
                                <i className="fa fa-filter" />&nbsp;
                                Filter
                              </div>
                            </button>
                          {/* {SyestemUserRole == "Tester" && */}
                            <Button
                              className="btn btn-primary btn-sm me-1"
                              onClick={() => !excelLoading ? addToSubdivisionList() : ""}
                            >
                              {excelLoading ?
                                <div className="spinner-border spinner-border-sm" role="status" />
                                :
                                <div style={{ fontSize: "11px" }}>
                                  <i className="fa fa-map-marker" aria-hidden="true" />&nbsp;
                                  Map
                                </div>
                              }
                            </Button>
                          {/* } */}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {subdivisionListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0 subdivion-table"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            <th>
                              <input
                                type="checkbox"
                                style={{ cursor: "pointer" }}
                                checked={(currentPage == samePage || isSelectAll) ? selectCheckBox : ""}
                                onClick={(e) => handleMainCheckboxChange(e)}
                              />
                            </th>
                            <th>
                              <strong> No.</strong>
                            </th>
                            {columns.map((column) => (
                              <th style={{ textAlign: "center", cursor: "pointer" }} key={column.id}>
                                <strong>
                                  {column.label}
                                  {column.id != "action" && sortConfig.some((item) => item.key === (
                                    column.id == "builder" ? "builderName" :
                                    column.id == "product Type" ? "product_type" :
                                    column.id == "master Plan" ? "masterplan_id" :
                                    column.id == "zIP Code" ? "zipcode" :
                                    column.id == "jurisdiction" ? "juridiction" :
                                    column.id == "total Lots" ? "totallots" :
                                    column.id == "lot Width" ? "lotwidth" :
                                    column.id == "lot Size" ? "lotsize" :
                                    column.id == "age Restricted" ? "age" :
                                    column.id == "all SingleStory" ? "single" :
                                    column.id == "cross Streets" ? "crossstreet" :
                                    column.id == "latitude" ? "lat" :
                                    column.id == "longitude" ? "lng" :
                                    column.id == "gas Provider" ? "gasprovider" :
                                    column.id == "hOA Fee" ? "hoafee" :
                                    column.id == "master Plan Fee" ? "masterplanfee" :
                                    column.id == "parcel Group" ? "parcel" :
                                    column.id == "date Added" ? "dateadded" :
                                    column.id == "date of First Permit" ? "date_of_first_permit" :
                                    column.id == "date of First Closing" ? "date_of_first_closing" :
                                    column.id == "date of Initial Land Purchase" ? "date_of_initial_land_purchase" :
                                    column.id == "__pkSubID" ? "subdivision_code" :
                                    column.id == "_fkBuilderID" ? "builder_code" :
                                    column.id == "open Since" ? "opensince" : toCamelCase(column.id))
                                  ) && (
                                    <span>
                                      {column.id != "action" && sortConfig.find(
                                        (item) => item.key === (
                                          column.id == "builder" ? "builderName" :
                                          column.id == "product Type" ? "product_type" :
                                          column.id == "master Plan" ? "masterplan_id" :
                                          column.id == "zIP Code" ? "zipcode" :
                                          column.id == "jurisdiction" ? "juridiction" :
                                          column.id == "total Lots" ? "totallots" :
                                          column.id == "lot Width" ? "lotwidth" :
                                          column.id == "lot Size" ? "lotsize" :
                                          column.id == "age Restricted" ? "age" :
                                          column.id == "all SingleStory" ? "single" :
                                          column.id == "cross Streets" ? "crossstreet" :
                                          column.id == "latitude" ? "lat" :
                                          column.id == "longitude" ? "lng" :
                                          column.id == "gas Provider" ? "gasprovider" :
                                          column.id == "hOA Fee" ? "hoafee" :
                                          column.id == "master Plan Fee" ? "masterplanfee" :
                                          column.id == "parcel Group" ? "parcel" :
                                          column.id == "date Added" ? "dateadded" :
                                          column.id == "date of First Permit" ? "date_of_first_permit" :
                                          column.id == "date of First Closing" ? "date_of_first_closing" :
                                          column.id == "date of Initial Land Purchase" ? "date_of_initial_land_purchase" :
                                          column.id == "__pkSubID" ? "subdivision_code" :
                                          column.id == "_fkBuilderID" ? "builder_code" :
                                          column.id == "open Since" ? "opensince" : toCamelCase(column.id))
                                      ).direction === "asc" ? "↑" : "↓"}
                                    </span>
                                  )
                                }
                              </strong>

                              {(!excelLoading) && (column.id !== "action" && column.id !== "status" && column.id !== "reporting" && column.id !== "builder" && column.id !== "name" &&
                                column.id !== "product Type" && column.id !== "area" && column.id !== "master Plan" && column.id !== "zIP Code" && column.id !== "zoning" &&
                                column.id !== "age Restricted" && column.id !== "all Single Story" && column.id !== "gated" && column.id !== "cross Streets" && column.id !== "jurisdiction" &&
                                column.id !== "latitude" && column.id !== "longitude" && column.id !== "gas Provider" && column.id !== "parcel Group" && column.id !== "phone" &&
                                column.id !== "website" && column.id !== "date Added" && column.id !== "__pkSubID" && column.id !== "_fkBuilderID" && column.id !== "latest Traffic/Sales Data" &&
                                column.id !== "max Week Ending" && column.id !== "min Week Ending" && column.id !== "sqft Group" && column.id !== "price Group" && column.id !== "open Since" &&
                                column.id !== "date of First Permit" && column.id !== "date of First Closing" && column.id !== "date of Initial Land Purchase"
                              ) && (
                                  <>
                                    <br />
                                    <select className="custom-select" value={column.id == "total Lots" ? totalLotsOption : column.id == "lot Width" ? lotWidthOption :
                                      column.id == "lot Size" ? lotSizeOption : column.id == "master Plan Fee" ? masterPlanFeeOption :
                                        column.id == "hOA Fee" ? hOAFeeOption : column.id == "total Closings" ? totalClosingsOption : column.id == "total Permits" ? totalPermitsOption :
                                        column.id == "total Net Sales" ? totalNetSalesOption : column.id == "months Open" ? monthsOpenOption :
                                        column.id == "latest Lots Released" ? latestLotsReleasedOption : column.id == "latest Standing Inventory" ? latestStandingInventoryOption :
                                        column.id == "unsold Lots" ? unsoldLotsOption : column.id == "avg Sqft All" ? avgSqftAllOption :
                                        column.id == "avg Sqft Active" ? avgSqftActiveOption : column.id == "avg Base Price All" ? avgBasePriceAllOption :
                                        column.id == "avg Base Price Active" ? avgBasePriceActiveOption : column.id == "min Sqft All" ? minSqftAllOption :
                                        column.id == "max Sqft All" ? maxSqftAllOption : column.id == "min Base Price All" ? minBasePriceAllOption :
                                        column.id == "min Sqft Active" ? minSqftActiveOption : column.id == "max Base Price All" ? maxBasePriceAllOption :
                                        column.id == "max Sqft Active" ? maxSqftActiveOption : column.id == "avg Net Traffic Per Month This Year" ? avgNetTrafficPerMonthThisYearOption :
                                        column.id == "avg Net Sales Per Month This Year" ? avgNetSalesPerMonthThisYearOption : column.id == "avg Closings Per Month This Year" ? avgClosingsPerMonthThisYearOption :
                                        column.id == "avg Net Sales Per Month Since Open" ? avgNetSalesPerMonthSinceOpenOption : column.id == "avg Net Sales Per Month Last 3 Months" ? avgNetSalesPerMonthLastThreeMonthsOption :
                                        column.id == "month Net Sold" ? monthNetSoldOption : column.id == "year Net Sold" ? yearNetSoldOption :
                                        column.id == "avg Closing Price" ? avgClosingPriceOption : column.id == "permits This Year" ? permitsThisYearOption :
                                        column.id == "median Closing Price Since Open" ? medianClosingPriceSinceOpenOption : column.id == "median Closing Price This Year" ? medianClosingPriceThisYearOption : ""
                                      }

                                      style={{
                                        cursor: "pointer",
                                        marginLeft: '0px',
                                        fontSize: "8px",
                                        padding: " 0 5px 0",
                                        height: "15px",
                                        color: "white",
                                        appearance: "auto"
                                      }}

                                      onChange={(e) => column.id == "total Lots" ? handleSelectChange(e.target.value, "totallots") :
                                        column.id == "lot Width" ? handleSelectChange(e.target.value, "lotwidth") :
                                        column.id == "lot Size" ? handleSelectChange(e.target.value, "lotsize") :
                                        column.id == "master Plan Fee" ? handleSelectChange(e.target.value, "masterplanfee") :
                                        column.id == "hOA Fee" ? handleSelectChange(e.target.value, "hoafee") :
                                        column.id == "total Closings" ? handleSelectChange(e.target.value, "total_closings") :
                                        column.id == "total Permits" ? handleSelectChange(e.target.value, "total_permits") :
                                        column.id == "total Net Sales" ? handleSelectChange(e.target.value, "total_net_sales") :
                                        column.id == "months Open" ? handleSelectChange(e.target.value, "months_open") :
                                        column.id == "latest Lots Released" ? handleSelectChange(e.target.value, "latest_lots_released") :
                                        column.id == "latest Standing Inventory" ? handleSelectChange(e.target.value, "latest_standing_inventory") :
                                        column.id == "unsold Lots" ? handleSelectChange(e.target.value, "unsold_lots") :
                                        column.id == "avg Sqft All" ? handleSelectChange(e.target.value, "avg_sqft_all") :
                                        column.id == "avg Sqft Active" ? handleSelectChange(e.target.value, "avg_sqft_active") :
                                        column.id == "avg Base Price All" ? handleSelectChange(e.target.value, "avg_base_price_all") :
                                        column.id == "avg Base Price Active" ? handleSelectChange(e.target.value, "avg_base_price_active") :
                                        column.id == "min Sqft All" ? handleSelectChange(e.target.value, "min_sqft_all") :
                                        column.id == "max Sqft All" ? handleSelectChange(e.target.value, "max_sqft_all") :
                                        column.id == "min Base Price All" ? handleSelectChange(e.target.value, "min_base_price_all") :
                                        column.id == "min Sqft Active" ? handleSelectChange(e.target.value, "min_sqft_active") :
                                        column.id == "max Base Price All" ? handleSelectChange(e.target.value, "max_base_price_all") :
                                        column.id == "max Sqft Active" ? handleSelectChange(e.target.value, "max_sqft_active") :
                                        column.id == "avg Net Traffic Per Month This Year" ? handleSelectChange(e.target.value, "avg_net_traffic_per_month_this_year") :
                                        column.id == "avg Net Sales Per Month This Year" ? handleSelectChange(e.target.value, "avg_net_sales_per_month_this_year") :
                                        column.id == "avg Closings Per Month This Year" ? handleSelectChange(e.target.value, "avg_closings_per_month_this_year") :
                                        column.id == "avg Net Sales Per Month Since Open" ? handleSelectChange(e.target.value, "avg_net_sales_per_month_since_open") :
                                        column.id == "avg Net Sales Per Month Last 3 Months" ? handleSelectChange(e.target.value, "avg_net_sales_per_month_last_three_months") :
                                        column.id == "month Net Sold" ? handleSelectChange(e.target.value, "month_net_sold") :
                                        column.id == "year Net Sold" ? handleSelectChange(e.target.value, "year_net_sold") :
                                        column.id == "avg Closing Price" ? handleSelectChange(e.target.value, "avg_closing_price") :
                                        column.id == "permits This Year" ? handleSelectChange(e.target.value, "permit_this_year") :
                                        column.id == "median Closing Price Since Open" ? handleSelectChange(e.target.value, "median_closing_price_since_open") :
                                        column.id == "median Closing Price This Year" ? handleSelectChange(e.target.value, "median_closing_price_this_year") : ""
                                      }
                                    >
                                      <option style={{ color: "black", fontSize: "10px" }} value="" disabled>CALCULATION</option>
                                      <option style={{ color: "black", fontSize: "10px" }} value="sum">Sum</option>
                                      <option style={{ color: "black", fontSize: "10px" }} value="avg">Avg</option>
                                    </select>
                                    <br />
                                  </>
                                )}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "center" }}>
                        {!excelLoading &&
                          <tr>
                            <td></td>
                            <td></td>
                            {columns.map((column) => (
                              <>
                                {column.id == "status" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "reporting" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "builder" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "name" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "product Type" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "area" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "master Plan" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "zIP Code" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "total Lots" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{totalLotsResult.toFixed(2)}</td>
                                }
                                {column.id == "lot Width" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{lotWidthResult.toFixed(2)}</td>
                                }
                                {column.id == "lot Size" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{lotSizeResult.toFixed(2)}</td>
                                }
                                {column.id == "zoning" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "age Restricted" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "all Single Story" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "gated" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "cross Streets" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "jurisdiction" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "latitude" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "longitude" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                 {column.id == "gas Provider" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "hOA Fee" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{hOAFeeResult.toFixed(2)}</td>
                                }
                                {column.id == "master Plan Fee" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{masterPlanFeeResult.toFixed(2)}</td>
                                }
                                {column.id == "parcel Group" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "phone" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "website" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "date Added" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "__pkSubID" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "_fkBuilderID" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "total Closings" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{totalClosingsResult.toFixed(2)}</td>
                                }
                                {column.id == "total Permits" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{totalPermitsResult.toFixed(2)}</td>
                                }
                                {column.id == "total Net Sales" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{totalNetSalesResult.toFixed(2)}</td>
                                }
                                {column.id == "months Open" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{monthsOpenResult.toFixed(2)}</td>
                                }
                                {column.id == "latest Traffic/Sales Data" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "latest Lots Released" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{latestLotsReleasedResult.toFixed(2)}</td>
                                }
                                {column.id == "latest Standing Inventory" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{latestStandingInventoryResult.toFixed(2)}</td>
                                }
                                {column.id == "unsold Lots" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{unsoldLotsResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Sqft All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgSqftAllResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Sqft Active" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgSqftActiveResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Base Price All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgBasePriceAllResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Base Price Active" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgBasePriceActiveResult.toFixed(2)}</td>
                                }
                                {column.id == "min Sqft All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{minSqftAllResult.toFixed(2)}</td>
                                }
                                {column.id == "max Sqft All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{maxSqftAllResult.toFixed(2)}</td>
                                }
                                {column.id == "min Base Price All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{minBasePriceAllResult.toFixed(2)}</td>
                                }
                                {column.id == "min Sqft Active" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{minSqftActiveResult.toFixed(2)}</td>
                                }
                                {column.id == "max Base Price All" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{maxBasePriceAllResult.toFixed(2)}</td>
                                }
                                {column.id == "max Sqft Active" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{maxSqftActiveResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Traffic Per Month This Year" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgNetTrafficPerMonthThisYearResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Net Sales Per Month This Year" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgNetSalesPerMonthThisYearResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Closings Per Month This Year" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgClosingsPerMonthThisYearResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Net Sales Per Month Since Open" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgNetSalesPerMonthSinceOpenResult.toFixed(2)}</td>
                                }
                                {column.id == "avg Net Sales Per Month Last 3 Months" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgNetSalesPerMonthLastThreeMonthsResult.toFixed(2)}</td>
                                }
                                {column.id == "max Week Ending" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "min Week Ending" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "sqft Group" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "price Group" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "month Net Sold" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{monthNetSoldResult.toFixed(2)}</td>
                                }
                                {column.id == "year Net Sold" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{yearNetSoldResult.toFixed(2)}</td>
                                }
                                {column.id == "open Since" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "avg Closing Price" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{avgClosingPriceResult.toFixed(2)}</td>
                                }
                                {column.id == "permits This Year" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{permitsThisYearResult.toFixed(2)}</td>
                                }
                                {column.id == "median Closing Price Since Open" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{medianClosingPriceSinceOpenResult.toFixed(2)}</td>
                                }
                                {column.id == "median Closing Price This Year" &&
                                  <td key={column.id} style={{ textAlign: "center" }}>{medianClosingPriceThisYearResult.toFixed(2)}</td>
                                }
                                {column.id == "date of First Permit" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "date of First Closing" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "date of Initial Land Purchase" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                                {column.id == "action" &&
                                  <td key={column.id} style={{ textAlign: "center" }}></td>
                                }
                              </>
                            ))}
                          </tr>}
                        {subdivisionList !== null && subdivisionList.length > 0 ? (
                          subdivisionList.map((element, index) => (
                            <tr
                              onClick={(e) => {
                                if (e.target.type === "checkbox") {
                                  return;
                                } else if (e.target.className === "btn btn-danger shadow btn-xs sharp" || e.target.className === "fa fa-trash") {
                                  return;
                                } else if (e.target.className === "btn btn-primary shadow btn-xs sharp me-1" || e.target.className === "fas fa-pencil-alt") {
                                  return;
                                } else if (e.target.className === "btn btn-primary shadow btn-xs sharp" || e.target.className === "fa fa-file-text") {
                                  return;
                                } else {
                                  handleRowClick(element.id);
                                }
                              }}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedLandSales.includes(element.id)}
                                  onChange={(e) => handleEditCheckboxChange(e, element.id)}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                />
                              </td>
                              <td>{index + 1}</td>
                              {columns.map((column) => (
                                <>
                                  {column.id == "status" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      {element.status === 1 && "Active"}
                                      {element.status === 0 && "Sold Out"}
                                      {element.status === 2 && "Future"}
                                    </td>
                                  }
                                  {column.id == "reporting" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      {element.reporting === 1 && "Yes"}
                                      {element.reporting === 0 && "No"}
                                    </td>
                                  }
                                  {column.id == "builder" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.builder.name}</td>
                                  }
                                  {column.id == "name" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.name}</td>
                                  }
                                  {column.id == "product Type" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.product_type}</td>
                                  }
                                  {column.id == "area" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.area}</td>
                                  }
                                  {column.id == "master Plan" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.masterplan_id}</td>
                                  }
                                  {column.id == "zIP Code" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.zipcode}</td>
                                  }
                                  {column.id == "total Lots" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.totallots}</td>
                                  }
                                  {column.id == "lot Width" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.lotwidth}</td>
                                  }
                                  {column.id == "lot Size" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.lotsize}</td>
                                  }
                                  {column.id == "zoning" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.zoning}</td>
                                  }
                                  {column.id == "age Restricted" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      {element.age === 1 && "Yes"}
                                      {element.age === 0 && "No"}
                                    </td>
                                  }
                                  {column.id == "all Single Story" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      {element.single === 1 && "Yes"}
                                      {element.single === 0 && "No"}
                                    </td>
                                  }
                                  {column.id == "gated" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      {element.gated === 1 && "Yes"}
                                      {element.gated === 0 && "No"}
                                    </td>
                                  }
                                  {column.id == "cross Streets" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.crossstreet}</td>
                                  }
                                  {column.id == "jurisdiction" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.juridiction}</td>
                                  }
                                  {column.id == "latitude" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.lat}</td>
                                  }
                                  {column.id == "longitude" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.lng}</td>
                                  }
                                  {column.id == "gas Provider" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.gasprovider}</td>
                                  }
                                  {column.id == "hOA Fee" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.hoafee}</td>
                                  }
                                  {column.id == "master Plan Fee" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.masterplanfee}</td>
                                  }
                                  {column.id == "parcel Group" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.parcel}</td>
                                  }
                                  {column.id == "phone" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.phone}</td>
                                  }
                                  {column.id == "website" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.website}</td>
                                  }
                                  {column.id == "date Added" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.dateadded} /></td>
                                  }
                                  {column.id == "__pkSubID" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.subdivision_code}</td>
                                  }
                                  {column.id == "_fkBuilderID" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.builder.builder_code}</td>
                                  }
                                  {column.id == "total Closings" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.total_closings}</td>
                                  }
                                  {column.id == "total Permits" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.total_permits}</td>
                                  }
                                  {column.id == "total Net Sales" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.total_net_sales}</td>
                                  }
                                  {column.id == "months Open" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.months_open}</td>
                                  }
                                  {column.id == "latest Traffic/Sales Data" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.latest_traffic_data} /></td>
                                  }
                                  {column.id == "latest Lots Released" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.latest_lots_released}</td>
                                  }
                                  {column.id == "latest Standing Inventory" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.latest_standing_inventory}</td>
                                  }
                                  {column.id == "unsold Lots" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.unsold_lots}</td>
                                  }
                                  {column.id == "avg Sqft All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_sqft_all}</td>
                                  }
                                  {column.id == "avg Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_sqft_active}</td>
                                  }
                                  {column.id == "avg Base Price All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.avg_base_price_all} /> || "NA"}</td>
                                  }
                                  {column.id == "avg Base Price Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.avg_base_price_active} /> || "NA"}</td>
                                  }
                                  {column.id == "min Sqft All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.min_sqft_all}</td>
                                  }
                                  {column.id == "max Sqft All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.max_sqft_all}</td>
                                  }
                                  {column.id == "min Base Price All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.min_base_price_all} /> || "NA"}</td>
                                  }
                                  {column.id == "min Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.min_sqft_active}</td>
                                  }
                                  {column.id == "max Base Price All" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<PriceComponent price={element.max_base_price_all} /> || "NA"}</td>
                                  }
                                  {column.id == "max Sqft Active" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.max_sqft_active}</td>
                                  }
                                  {column.id == "avg Traffic Per Month This Year" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_net_traffic_per_month_this_year}</td>
                                  }
                                  {column.id == "avg Net Sales Per Month This Year" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_net_sales_per_month_this_year}</td>
                                  }
                                  {column.id == "avg Closings Per Month This Year" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_closings_per_month_this_year}</td>
                                  }
                                  {column.id == "avg Net Sales Per Month Since Open" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_net_sales_per_month_since_open}</td>
                                  }
                                  {column.id == "avg Net Sales Per Month Last 3 Months" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.avg_net_sales_per_month_last_three_months}</td>
                                  }
                                  {column.id == "max Week Ending" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<DateComponent date={element.max_week_ending} /> || "NA"}</td>
                                  }
                                  {column.id == "min Week Ending" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{<DateComponent date={element.min_week_ending} /> || "NA"}</td>
                                  }
                                  {column.id == "sqft Group" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.sqft_group}</td>
                                  }
                                  {column.id == "price Group" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.price_group ? element.price_group.group : ""}</td>
                                  }
                                  {column.id == "month Net Sold" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.month_net_sold}</td>
                                  }
                                  {column.id == "year Net Sold" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.year_net_sold}</td>
                                  }
                                  {column.id == "open Since" &&
                                    <td key={column.id} style={{ textAlign: "center" }}> <DateComponent date={element.opensince} /></td>
                                  }
                                  {column.id == "avg Closing Price" &&
                                    <td key={column.id} style={{ textAlign: "center" }}> <PriceComponent price={element.avg_closing_price} /></td>
                                  }
                                  {column.id == "permits This Year" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>{element.permit_this_year}</td>
                                  }
                                  {column.id == "median Closing Price Since Open" &&
                                    <td key={column.id} style={{ textAlign: "center" }}> <PriceComponent price={element.median_closing_price_since_open} /></td>
                                  }
                                  {column.id == "median Closing Price This Year" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><PriceComponent price={element.median_closing_price_this_year} /></td>
                                  }
                                  {column.id == "date of First Permit" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.date_of_first_permit} /></td>
                                  }
                                  {column.id == "date of First Closing" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.date_of_first_closing} /></td>
                                  }
                                  {column.id == "date of Initial Land Purchase" &&
                                    <td key={column.id} style={{ textAlign: "center" }}><DateComponent date={element.date_of_initial_land_purchase} /></td>
                                  }
                                  {column.id == "action" &&
                                    <td key={column.id} style={{ textAlign: "center" }}>
                                      <div>
                                        <Link
                                          to={`/subdivisionUpdate/${element.id}?page=${currentPage}`}
                                          className="btn btn-primary shadow btn-xs sharp me-1"
                                        >
                                          <i className="fas fa-pencil-alt"></i>
                                        </Link>
                                        <Link
                                          onClick={() =>
                                            swal({
                                              title: "Are you sure?",
                                              icon: "warning",
                                              buttons: true,
                                              dangerMode: true,
                                            }).then((willDelete) => {
                                              if (willDelete) {
                                                handleDelete(element.id);
                                              }
                                            })
                                          }
                                          className="btn btn-danger shadow btn-xs sharp"
                                        >
                                          <i className="fa fa-trash"></i>
                                        </Link>
                                      </div>
                                    </td>
                                  }
                                </>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="15" style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                  <div className="dataTables_info">
                    Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                    {subdivisionListCount} entries
                  </div>
                  <div
                    className="dataTables_paginate paging_simple_numbers justify-content-center"
                    id="example2_paginate"
                  >
                    <Link
                      className="paginate_button previous disabled"
                      to="#"
                      onClick={prePage}
                    >
                      <i className="fa-solid fa-angle-left" />
                    </Link>
                    <span>
                      {number.map((n, i) => {
                        if (number.length > 4) {
                          if (
                            i === 0 ||
                            i === number.length - 1 ||
                            Math.abs(currentPage - n) <= 1 ||
                            (i === 1 && n === 2) ||
                            (i === number.length - 2 &&
                              n === number.length - 1)
                          ) {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          } else if (i === 1 || i === number.length - 2) {
                            return <span key={i}>...</span>;
                          } else {
                            return null;
                          }
                        } else {
                          return (
                            <Link
                              className={`paginate_button ${currentPage === n ? "current" : ""
                                } `}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          );
                        }
                      })}
                    </span>

                    <Link
                      className="paginate_button next"
                      to="#"
                      onClick={nextPage}
                    >
                      <i className="fa-solid fa-angle-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
      <SubdivisionOffcanvas
        canvasShowAdd={canvasShowAdd}
        seCanvasShowAdd={seCanvasShowAdd}
        Title="Add Subdivision"
        parentCallback={handleCallback}
      />
      <BulkSubdivisionUpdate
        canvasShowEdit={canvasShowEdit}
        seCanvasShowEdit={seCanvasShowEdit}
        Title={selectedLandSales?.length  === 1 ? "Edit Subdivision" : "Bulk Edit Subdivisions"}
        parentCallback={handleCallback}
        selectedLandSales={selectedLandSales}
        setSelectedLandSales={setSelectedLandSales}
      />

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Import Subdivision CSV Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-3">
            <input type="file" id="fileInput" onChange={handleFileChange} />
          </div>
          <p className="text-danger d-flex justify-content-center align-item-center mt-1">
            {selectedFileError || Error}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUploadClick}
            disabled={loading}
          >
            {loading ? "Loading.." : "Import"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Sorting */ }
      <Modal show={showSortingPopup} onHide={HandleSortingPopupDetailClick}>
        <Modal.Header handleSortingPopupClose>
          <Modal.Title>Sorted Fields</Modal.Title>
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => handleSortingPopupClose()}
          ></button>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <div className="row">
            <div style={{ marginTop: "-15px" }}>
              <label className="form-label" style={{ fontWeight: "bold", fontSize: "15px" }}>List of Fields:</label>
              <div className="field-checkbox-list">
                <div className="form-check d-flex align-items-center mb-2" style={{ width: '100%' }}>
                  <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="select-all-fields"
                      checked={selectedFields.length === fieldOptions.length}
                      onChange={handleSelectAllChange}
                      style={{ marginRight: '0.2rem', cursor: "pointer" }}
                    />
                    <label className="form-check-label mb-0" htmlFor="select-all-fields" style={{ width: "150px", cursor: "pointer" }}>
                      Select All
                    </label>
                  </div>
                </div>

                {fieldOptions.map((field, index) => {
                  const isChecked = selectedFields.some(selected => selected.value === field.value);
                  const fieldOrder = selectionOrder[field.value]; // Get the selection order

                  return (
                    <div key={index} className="form-check d-flex align-items-center mb-2" style={{ width: '100%', height: "35px" }}>
                      <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`field-checkbox-${index}`}
                          value={field.value}
                          checked={isChecked}
                          onChange={(e) => handleSortingCheckboxChange(e, field)}
                          style={{ marginRight: '0.2rem', cursor: "pointer" }}
                        />
                        <label className="form-check-label mb-0" htmlFor={`field-checkbox-${index}`} style={{ width: "150px", cursor: "pointer" }}>
                          {isChecked && <span>{fieldOrder}. </span>} {/* Display selection number */}
                          {field.label}
                        </label>
                      </div>

                      {isChecked && (
                        <div className="radio-group d-flex" style={{ flex: '0 0 60%', paddingTop: "5px" }}>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`asc-${field.value}`}
                              value="asc"
                              checked={sortOrders[field.value] === 'asc' || !sortOrders[field.value]}
                              onChange={() => handleSortOrderChange(field.value, 'asc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`asc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-40px" }}>
                              Ascending
                            </label>
                          </div>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`desc-${field.value}`}
                              value="desc"
                              checked={sortOrders[field.value] === 'desc'}
                              onChange={() => handleSortOrderChange(field.value, 'desc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`desc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-30px" }}>
                              Descending
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSortingPopupClose} style={{ marginRight: "10px" }}>Close</Button>
          <Button variant="success" onClick={() => handleApplySorting(selectedFields, sortOrders)}>Apply</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas
        show={showOffcanvas}
        onHide={setShowOffcanvas}
        className="offcanvas-end customeoff customoff-subdivision"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Subdivision Details
            {!isFormLoading && <button
              className="btn btn-primary btn-sm me-1" 
              title="Subdivision Analysis Report"
              style={{ marginLeft: "20px" }}
              onClick={() => handleDownloadReport()}
              key={subdivisionID}
            >
              {loadingReportId === subdivisionID ? (
                <div className="spinner-border spinner-border-sm" role="status" style={{ marginTop: "1px" }} />
              ) : (
                <div>
                  <i className="fa fa-file-text" aria-hidden="true" />&nbsp;
                  Subdivision Analysis Report
                </div>
              )}
            </button>}
          </h5>
          
          
          <button
            type="button"
            className="btn-close"
            onClick={() => { setShowOffcanvas(false); clearSubdivisionDetails(); }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        {isFormLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
            <ClipLoader color="#4474fc" />
          </div>
        ) : (
          <div className="offcanvas-body">
            <div className="container-fluid">
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box>
                    <TabList
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab label="Subdivision Details" value="1" />
                      <Tab label="Products" value="2" />
                      <Tab label="Permits" value="3" />
                      <Tab label="Traffic & Sales" value="4" />
                      <Tab label="Closings" value="5" />
                      <Tab label="Land Sales" value="6" />
                      <Tab label="Parcel List" value="7" />
                      {/* <Tab label="Traffic & Sales" value="6" /> */}
                    </TabList>
                  </Box>
                  {/* Subdivision Details */}
                  <TabPanel value="1" className="p-0">
                    <div className="d-flex">

                      <div style={{ width: "60%" }}>

                        <div style={{ marginTop: "10px" }}>
                          <span className="fw-bold fs-20">
                            {SubdivisionDetails.builder && SubdivisionDetails.builder.name !== undefined
                              ? SubdivisionDetails.builder.name
                              : "NA"}
                          </span><br />
                          <span className="fw-bold fs-30">
                            {SubdivisionDetails.name || "NA"}
                          </span><br />

                       {SubdivisionDetails.website && (
                        <>
                          <a
                            style={{
                    display: "block",
                    paddingRight: "63px",
                    wordWrap: "break-word",
                    color:"#1976d2"
                  }}

                          target="_blank" href={SubdivisionDetails.website}>{SubdivisionDetails.website}</a>
                          <br />
                        </>
                      )}

                        

                          <label className="fs-18" style={{ marginTop: "10px" }}><b>PHONE:</b>&nbsp;<span>{SubdivisionDetails.phone || "NA"}</span></label><br />
                          <label className="fs-18"><b>PRODUCT TYPE:</b>&nbsp;<span>{SubdivisionDetails.product_type || "NA"}</span></label><br />
                          <label className="fs-18"><b>OPEN SINCE:</b>&nbsp;<span>{SubdivisionDetails.opensince || "NA"}</span></label><br />
                          <label className="fs-18"><b>DATE OF FIRST PERMIT:</b>&nbsp;<span>{SubdivisionDetails.date_of_first_permit || "NA"}</span></label><br />
                          <label className="fs-18"><b>DATE OF FIRST CLOSING:</b>&nbsp;<span>{SubdivisionDetails.date_of_first_closing || "NA"}</span></label><br />
                          <label className="fs-18"><b>DATE OF INITIAL LAND PURCHASE:</b>&nbsp;<span>{SubdivisionDetails.date_of_initial_land_purchase || "NA"}</span></label><br />
                          <label className="fs-18"><b>AGE RESTRICTED:</b>&nbsp;
                            <span className="fw-bold">
                              {SubdivisionDetails.age === 0 && "No"}
                              {SubdivisionDetails.age === 1 && "Yes"}
                              {SubdivisionDetails.age === "" && "NA"}
                            </span>
                          </label><br />
                          <label className="fs-18"><b>ALL SINGLE-STORY:</b>&nbsp;
                            <span className="fw-bold">
                              {SubdivisionDetails.single === 0 && "No"}
                              {SubdivisionDetails.single === 1 && "Yes"}
                              {SubdivisionDetails.single === "" && "NA"}
                            </span>
                          </label><br />
                          <label className="fs-18"><b>GATED:</b>&nbsp;<span>{SubdivisionDetails.gated || "NA"}</span></label>

                          <hr style={{ borderTop: "2px solid black", width: "80%", marginTop: "0px", marginBottom: "10px" }}></hr>

                          <div className="d-flex" style={{ marginTop: "5px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>AREA:</b></span>&nbsp;<span>{SubdivisionDetails.area || "NA"}</span></div>
                            <div className="fs-18"><span><b>MASTER PLAN:</b></span>&nbsp;<span>{SubdivisionDetails.masterplan_id || "NA"}</span></div>
                          </div>
                          <label className="fs-18" style={{ marginTop: "5px" }}><b>ZIP CODE:</b>&nbsp;<span>{SubdivisionDetails.zipcode || "NA"}</span></label><br />
                          <label className="fs-18"><b>CROSS STREETS:</b>&nbsp;<span>{SubdivisionDetails.crossstreet || "NA"}</span></label><br />
                          <label className="fs-18"><b>JURISDICTION:</b>&nbsp;<span>{SubdivisionDetails.juridiction || "NA"}</span></label>
                          <div className="d-flex" style={{ marginTop: "0px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>LATITUDE:</b></span>&nbsp;<span>{SubdivisionDetails.lat || "NA"}</span></div>
                            <div className="fs-18"><span><b>LONGITUDE:</b></span>&nbsp;<span>{SubdivisionDetails.lng || "NA"}</span></div>
                          </div>
                          <label className="fs-18" style={{ marginTop: "5px" }}><b>PARCEL:</b>&nbsp;<span>{SubdivisionDetails.parcel || "NA"}</span></label>

                          <hr style={{ borderTop: "2px solid black", width: "80%", marginTop: "0px", marginBottom: "10px" }}></hr>

                          <div className="d-flex" style={{ marginTop: "5px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>TOTAL LOTS:</b></span>&nbsp;<span>{SubdivisionDetails.totallots || "NA"}</span></div>
                            <div className="fs-18"><span><b>TOTAL RELEASED:</b></span>&nbsp;<span>{SubdivisionDetails.latest_lots_released || "NA"}</span></div>
                          </div>
                          <div className="d-flex" style={{ marginTop: "5px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>UNSOLD LOTS:</b></span>&nbsp;<span>{SubdivisionDetails.unsold_lots || "NA"}</span></div>
                            <div className="fs-18"><span><b>STANDING INVENTORY:</b></span>&nbsp;<span>{SubdivisionDetails.stadinginventory || "NA"}</span></div>
                          </div>
                          <div className="d-flex" style={{ marginTop: "5px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>LOT WIDTH:</b></span>&nbsp;<span>{SubdivisionDetails.lotwidth || "NA"}</span></div>
                            <div className="fs-18"><span><b>LOT SIZE:</b></span>&nbsp;<span>{SubdivisionDetails.lotsize || "NA"}</span></div>
                          </div>

                          <hr style={{ borderTop: "2px solid black", width: "80%", marginTop: "5px", marginBottom: "10px" }}></hr>

                          <div className="d-flex" style={{ marginTop: "5px" }}>
                            <div className="fs-18" style={{ width: "180px" }}><span><b>HOA FEE:</b></span>&nbsp;<span>{SubdivisionDetails.hoafee || "NA"}</span></div>
                            <div className="fs-18"><span><b>MASTER PLAN FEE:</b></span>&nbsp;<span>{SubdivisionDetails.masterplanfee || "NA"}</span></div>
                          </div>
                          <label className="fs-18" style={{ marginTop: "5px", marginBottom: "5px" }}><b>GAS PROVIDER:</b>&nbsp;<span>{SubdivisionDetails.gasprovider || "NA"}</span></label><br />
                          <label className="fs-18"><b>ZONING:</b>&nbsp;<span>{SubdivisionDetails.zoning || "NA"}</span></label>

                        </div>
                      </div>

                      <div style={{ width: "40%" }}>

                        <div className="d-flex" style={{ marginTop: "10px" }}>
                          <div style={{ width: "50%" }}>
                            <label className="fs-20" style={{ marginBottom: "0px" }}><b>STATUS:</b></label>
                            <div>
                              <span className="" style={{ marginTop: "1px" }}>
                                {SubdivisionDetails.status === 1 && "Active"}
                                {SubdivisionDetails.status === 0 && "De-acitve"}
                                {SubdivisionDetails.status === 2 && "Future"}
                              </span>
                            </div>
                          </div>
                          <div>
                            <label className="fs-20" style={{ marginBottom: "0px" }}><b>REPORTING?:</b></label>
                            <div>
                              <span className="" style={{ marginTop: "1px" }}>
                                {SubdivisionDetails.reporting === 1 && "Yes"}
                                {SubdivisionDetails.reporting === 0 && "No"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className="fs-20" style={{ marginBottom: "0px" }}><b>CURRENT AVG BASE ASKING $:</b></label>
                          <div >
                            <span className="">{<PriceComponent price={SubdivisionDetails.avg_base_price_active} /> || "NA"}</span>
                          </div>
                          <label className="fs-20"><b>CURRENT AVG SQFT:</b>&nbsp;<span style={{ fontSize: "16px" }}>{SubdivisionDetails.avg_sqft_active || "NA"}</span></label>
                        </div>

                        <div style={{ border: "1px solid black", marginTop: "10px" }}>
                          <div style={{ marginLeft: "5px" }}>
                            <label className="fs-20" style={{ marginBottom: "0px" }}><b>TOTAL SINCE OPEN:</b></label><br />
                            <label style={{ marginLeft: "15px" }}>NET SALES:&nbsp;{SubdivisionDetails.total_net_sales || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>PERMITS:&nbsp;{SubdivisionDetails.total_permits || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>CLOSINGS:&nbsp;{SubdivisionDetails.total_closings || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>NET SALES PER MO:&nbsp;{SubdivisionDetails.avg_net_sales_per_month_since_open || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>CLOSINGS PER MO:
                              {
                              SubdivisionDetails.months_open > 0 && SubdivisionDetails.total_closings > 0
                                ? (SubdivisionDetails.total_closings / SubdivisionDetails.months_open).toFixed(2)
                                : "NA"
                            }
                            &nbsp;</label><br />
                            <label style={{ marginLeft: "15px" }}>MED. CLOSINGS $:&nbsp;{<PriceComponent price={SubdivisionDetails.median_closing_price_since_open} /> || "NA"}</label><br />

                            <label className="fs-20" style={{ marginBottom: "0px" }}><b>THIS YEAR:</b></label><br />
                            <label style={{ marginLeft: "15px" }}>NET SALES:&nbsp;{SubdivisionDetails.year_net_sold || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>PERMITS:&nbsp;{SubdivisionDetails.permit_this_year || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>CLOSINGS:&nbsp;{SubdivisionDetails?.closing_this_year || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>NET SALES PER MO:&nbsp;{SubdivisionDetails.avg_net_sales_per_month_this_year || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>CLOSINGS PER MO:&nbsp;{SubdivisionDetails.avg_closings_per_month_this_year || "NA"}</label><br />
                            <label style={{ marginLeft: "15px" }}>MED. CLOSINGS $:&nbsp;{<PriceComponent price={SubdivisionDetails.median_closing_price_this_year} /> || "NA"}</label><br />
                          </div>
                        </div>

                      </div>

                    </div>
                  </TabPanel>

                  {/* Products */}
                  <TabPanel value="2" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-product mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th ><strong>No.</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("name")}><strong>Name {getSortIcon("name")}</strong></th>
                                  <th  style={{cursor:"pointer"}} onClick={() => requestSort("status")}><strong>Status</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("sqft")}><strong>SqFt {getSortIcon("sqft")}</strong></th>
                                  <th  style={{cursor:"pointer"}} onClick={() => requestSort("stories")}><strong>Stories {getSortIcon("stories")}</strong></th>
                                  <th  style={{cursor:"pointer"}} onClick={() => requestSort("bedroom")}><strong>Bedrooms {getSortIcon("bedroom")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("bathroom")}><strong>Baths {getSortIcon("bathroom")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("garage")}><strong>Garage {getSortIcon("garage")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("recentprice")}><strong>Base Price {getSortIcon("recentprice")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("current_price_per_sqft")}><strong>$/Sqft {getSortIcon("current_price_per_sqft")}</strong></th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                                { sortedData.length > 0 ? (
                                  sortedData.map(
                                    (element, index) => (
                                      <tr
                                        onClick={() => handleProductRedirect(element.id, element.name)}
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{element.name}</td>
                                        <td>{getStatusLabel(element.status)}</td>
                                        <td>{element.sqft}</td>
                                        <td>{element.stories}</td>
                                        <td>{element.bedroom}</td>
                                        <td>{element.bathroom}</td>
                                        <td>{element.garage}</td>
                                        <td>{element.recentprice ? <PriceComponent price={element.recentprice} /> : ""}</td>
                                        <td>{element.current_price_per_sqft ? <PriceComponent price={element.current_price_per_sqft} /> : ""}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="9"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Permits */}
                  <TabPanel value="3" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-permit mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th>No.</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("date")}>Date {getSortIcon("date")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("address2")}>Address Number {getSortIcon("address2")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("address1")}>Address Name {getSortIcon("address1")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("parcel")}>Parcel {getSortIcon("parcel")}</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                                { sortedData.length > 0 ? (
                                  sortedData.map(
                                    (element, index) => (
                                      <tr
                                        onClick={() =>
                                          handlePermitRedirect(element.id, element.date)
                                        }
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{<DateComponent date={element.date} />}</td>
                                        <td>{element.address2}</td>
                                        <td>{element.address1}</td>
                                        <td>{element.parcel}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="5"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* Traffic & Sales */}
                  <TabPanel value="4" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-permit mb-0"
                            >
                              <thead>
  <tr style={{ textAlign: "center" }}>
    <th >No.</th>
    <th style={{cursor:"pointer"}} onClick={() => requestSort("weekending")}>Week Ending {getSortIcon("weekending")}
</th>
    <th style={{cursor:"pointer"}} onClick={() => requestSort("weeklytraffic")}>Weekly Traffic {getSortIcon("weeklytraffic")}</th>
    <th style={{cursor:"pointer"}} onClick={() => requestSort("grosssales")}>Weekly Sales {getSortIcon("grosssales")}</th>
    <th style={{cursor:"pointer"}} onClick={() => requestSort("cancelations")}>Weekly Cancellations {getSortIcon("cancelations")}</th>
    <th style={{cursor:"pointer"}} onClick={() => requestSort("netsales")}>Weekly Net Sales {getSortIcon("netsales")}</th>
  </tr>
</thead>
<tbody>
  {sortedData.length > 0 ? (
    sortedData.map((element, index) => (
      <tr
        key={element.id}
        onClick={() => handleTrafficRedirect(element.id, element.weekending)}
        style={{ textAlign: "center", cursor: "pointer" }}
      >
        <td>{index + 1}</td>
        <td><DateComponent date={element.weekending} /></td>
        <td>{element.weeklytraffic}</td>
        <td>{element.grosssales}</td>
        <td>{element.cancelations}</td>
        <td>{element.netsales}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center" }}>No data found</td>
    </tr>
  )}
</tbody>

                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Closings */}
                  <TabPanel value="5" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-closing mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th>No.</th>

                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("closingdate")}>Date  {getSortIcon("closingdate")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("parcel")}>Parcel {getSortIcon("parcel")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("closingprice")}>Price{getSortIcon("closingprice")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("buyer")}>Buyer{getSortIcon("buyer")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("lender")}>Lender{getSortIcon("lender")}</th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("loanamount")}>Loan Amt{getSortIcon("loanamount")}</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                               {sortedData.length > 0 ? (
                                       sortedData.map((element, index) => (
                                      <tr
                                        onClick={() => handleClosingRedirect(element.id, element.closingdate)}
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{element.closingdate ? <DateComponent date={element.closingdate} /> : ""}</td>
                                        <td>{element.parcel}</td>
                                        <td>{element.closingprice ? <PriceComponent price={element.closingprice} /> : ""}</td>
                                        <td>{element.buyer}</td>
                                        <td>{element.lender}</td>
                                        <td>{element.loanamount ? <PriceComponent price={element.loanamount} /> : ""}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Land Sales */}
                  <TabPanel value="6" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-landsale mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th><strong>No.</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("date")}><strong>Date  {getSortIcon("date")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("parcel")}><strong>Parcel {getSortIcon("parcel")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("price")}><strong>Price {getSortIcon("price")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("noofunit")}><strong>Size {getSortIcon("noofunit")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("typeofunit")}><strong>Size MS {getSortIcon("typeofunit")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("price_per")}><strong>Price Per {getSortIcon("price_per")}</strong></th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                                { sortedData.length > 0 ? (
                                  sortedData.map(
                                    (element, index) => (
                                      <tr
                                        onClick={() => handleLandRedirect(element.id, element.date)}
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{element.date ? <DateComponent date={element.date} /> : ""}</td>
                                        <td>{element.parcel}</td>
                                        <td>{element.price ? <PriceComponent price={element.price} /> : ""}</td>
                                        <td>{element.noofunit}</td>
                                        <td>{element.typeofunit}</td>
                                        <td>{element.price_per ? <PriceComponent price={element.price_per} /> : ""}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Parcel List */}
                  <TabPanel value="7" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer subdivision-table-landsale mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  <th ><strong>No.</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("parcel")}><strong>Parcel  {getSortIcon("parcel")}</strong></th>
                                  <th style={{cursor:"pointer"}} onClick={() => requestSort("loc_strno")}><strong>Full Address  {getSortIcon("loc_strno")}</strong></th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                                {sortedData.length > 0 ? (
                                  sortedData.map(
                                    (element, index) => (
                                      <tr
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{element.parcel}</td>
                                        <td style={{ textAlign: "center" }}>{(element?.loc_strno == 0 || element?.loc_strno == null) ? "" : (element?.loc_strno + " " + element?.loc_strname)}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* <TabPanel value="6" className="p-0">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                          <div
                            id="employee-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="empoloyees-tblwrapper"
                              className="table ItemsCheckboxSec dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr style={{ textAlign: "center" }}>
                                  {" "}
                                  <th>No.</th>
                                  <th>Week Ending</th>
                                  <th>Weekly Traffic</th>
                                  <th>Gross Sales</th>
                                  <th>Cancelations</th>
                                  <th>Net Sales</th>
                                  <th>Lot Released</th>
                                  <th>Unsold Inventory</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "center" }}>
                                {SubdivisionDetails.trafic_sales &&
                                  Array.isArray(SubdivisionDetails.trafic_sales) &&
                                  SubdivisionDetails.trafic_sales.length > 0 ? (
                                  SubdivisionDetails.trafic_sales.map(
                                    (element, index) => (
                                      <tr
                                        onClick={handleTraficRedirect}
                                        key={element.id}
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <td>{index + 1}</td>
                                        <td>{element.weekending}</td>
                                        <td>{element.weeklytraffic}</td>
                                        <td>{element.grosssales}</td>
                                        <td>{element.cancelations}</td>
                                        <td>{element.netsales}</td>
                                        <td>{element.lotreleased}</td>
                                        <td>{element.unsoldinventory}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="9"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel> */}
                </TabContext>
              </Box>
            </div>
          </div>)}
      </Offcanvas>
      <Offcanvas
        show={manageAccessOffcanvas}
        onHide={setManageAccessOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Manage Subdivision Fields Access{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageAccessOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <label className="form-label">
              Select Role:
            </label>
            <select
              className="default-select form-control"
              name="manage_role_fields"
              onChange={HandleRole}
              value={role}
            >
              <option value="Admin">Admin</option>
              <option value="Staff">Staff</option>
              <option value="Standard User">Standard User</option>
              <option value="Data Uploader">Data Uploader</option>
              <option value="Account Admin">Account Admin</option>
            </select>
            <form onSubmit={handleAccessForm}>
              <div className="row">
                {Array.isArray(accessList) &&
                  accessList.map((element, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="mt-5">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkedItems[element.field_name]}
                            onChange={handleCheckboxChange}
                            name={element.field_name}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexCheckDefault${index}`}
                          >
                            {element.field_name}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <button type="submit" className="btn btn-primary mt-3">
                Submit
              </button>
            </form>
          </div>
        </div>
      </Offcanvas>

      <Offcanvas
        show={manageFilterOffcanvas}
        onHide={setManageFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Filter Subdivision{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageFilterOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <div className="">
              <form onSubmit={HandleFilterForm}>
                <div className="row">
                  <div className="col-md-3 mt-3">
                    <label className="form-label">STATUS:{" "}
                                <span className="text-danger">*</span></label>
                    <MultiSelect
                      name="status"
                      options={statusOptions}
                      value={selectedStatus}
                      onChange={handleSelectStatusChange}
                      placeholder={"Select Status"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">REPORTING:
                      <div className="btn-tooltip" id="reporting">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#reporting"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Is the Subdivision <br /> reporting <br /> to our "Weekly<br /> Traffic & Sales Watch"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <MultiSelect
                      name="reporting"
                      options={reportingOptions}
                      value={selectedReporting}
                      onChange={handleSelectReportingChange}
                      placeholder={"Select Reporting"}
                      hasSelectAll={true}
                    />
                  </div>

                  <div className="col-md-3 mt-3">
                    <label className="form-label">BUILDER NAME:</label>
                    <Form.Group controlId="tournamentList">
                      <MultiSelect
                        name="builder_name"
                        options={builderListDropDown}
                        value={selectedBuilderName}
                        onChange={handleSelectBuilderNameChange}
                        placeholder={"Select Builder Name"}
                        hasSelectAll={true}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-3 mt-3">
                    <label className="form-label">NAME:</label>
                    <Form.Group controlId="tournamentList">
                      <LazySubdivisionMultiSelect
                        builderIds={selectedBuilderIDByFilter}
                        name="name"
                        value={selectedSubdivisionName}
                        onChange={handleSelectSubdivisionNameChange}
                        placeholder={"Select Subdivision Name"}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-3 mt-3">
                    <label htmlFor="exampleFormControlInput6" className="form-label">PRODUCT TYPE:
                      <div className="btn-tooltip" id="productType">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#productType"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              DET: Single Family<br /> Detached ATT: Attached ie.<br /> Condol Townhome Duplex, <br />etc. HR: High Rise
                            </>
                          }
                        />
                      </div>
                    </label>
                    <MultiSelect
                      name="product_type"
                      options={productTypeOptions}
                      value={productTypeStatus}
                      onChange={handleSelectProductTypeChange}
                      placeholder="Select Product Type"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">AREA:  <div className="btn-tooltip" id="area">
                      <IoMdInformationCircleOutline height={20} width={20} />
                      <Tooltip
                        anchorSelect="#area"
                        style={{ zIndex: 999 }}
                        clickable={true}
                        content={
                          <>
                            See our Sub-Market<br /> Area Map:{" "}
                            <a
                              href="https://www.homebuildersresearch.com/images/misc/sub_market_areas.png"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Map
                            </a>
                          </>
                        }
                      />
                    </div>
                    </label>
                    <MultiSelect
                      name="area"
                      options={areaOption}
                      value={selectedArea}
                      onChange={handleSelectAreaChange}
                      placeholder="Select Area"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">MASTER PLAN:</label>
                    <MultiSelect
                      name="masterplan_id"
                      options={masterPlanDropDownList}
                      value={selectedMasterPlan}
                      onChange={handleSelectMasterPlanChange}
                      placeholder="Select Master Plan"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">ZIP CODE:</label>
                    <Form.Group controlId="tournamentList">
                      <MultiSelect
                        name="zipcode"
                        options={zipCodeDropDown}
                        value={selectedZipCode}
                        onChange={handleSelectZipCodeChange}
                        placeholder={"Select ZipCode"}
                        hasSelectAll={true}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">LOT WIDTH:
                      <div className="btn-tooltip" id="lotwidth">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#lotwidth"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Approximate<br /> average lot width
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input type="text" name="lotwidth" value={filterQuery.lotwidth} className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label className="form-label">LOT SIZE:
                      <div className="btn-tooltip" id="lotsize">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#lotsize"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Approximate <br /> average lot size
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input type="text" value={filterQuery.lotsize} name="lotsize" className="form-control" onChange={HandleFilter} />
                  </div>
                  <div className="col-md-3 mt-3">
                    <label htmlFor="exampleFormControlInput8" className="form-label">AGE RESTRICTED:</label>
                    <MultiSelect
                      name="age"
                      options={ageOptions}
                      value={selectedAge}
                      onChange={handleSelectAgeChange}
                      placeholder={"Select Age"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 ">
                    <label htmlFor="exampleFormControlInput8" className="form-label">All SINGLE STORY:</label>
                    <MultiSelect
                      name="single"
                      options={singleOptions}
                      value={selectedSingle}
                      onChange={handleSelectSingleChange}
                      placeholder={"Select Single"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label htmlFor="exampleFormControlInput28" className="form-label">GATED:</label>
                    <MultiSelect
                      name="gated"
                      options={gatedOptions}
                      value={selectedGated}
                      onChange={handleSelectGatedChange}
                      placeholder={"Select Gated"}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">JURISDICTION:</label>
                    <MultiSelect
                      name="juridiction"
                      options={jurisdictionOption}
                      value={selectedJurisdicition}
                      onChange={handleSelectJurisdictionChange}
                      placeholder="Select Jurisdiction"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">GAS PROVIDER:</label>
                    <MultiSelect
                      name="gasprovider"
                      options={gasProviderDropDown}
                      value={seletctedGasProvider}
                      onChange={handleGasProviderChange}
                      placeholder="Select Gas Provider"
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-6 mt-3 mb-3">
                    <div
                      className="d-flex flex-column"
                      style={{
                        border: "1px solid #cccccc",
                        borderRadius: "0.375rem",
                        padding: "0 12px"
                      }}
                    >
                      <label
                        className="form-label"
                        style={{ marginTop: "10px" }}
                      >
                        OPEN SINCE
                      </label>
                      <hr style={{ marginTop: "0px" }} />
                      <div className="d-flex gap-4 mb-3">
                        <div style={{ flex: 1 }}>
                          <label className="form-label">FROM:</label>
                          <DatePicker
                            name="from"
                            className="form-control"
                            selected={
                              filterQuery.from
                                ? parseDate(filterQuery.from)
                                : null
                            }
                            onChange={handleFilterDateFrom}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <label className="form-label">TO:</label>
                          <DatePicker
                            name="to"
                            className="form-control"
                            selected={
                              filterQuery.to
                                ? parseDate(filterQuery.to)
                                : null
                            }
                            onChange={handleFilterDateTo}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="mm/dd/yyyy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            &nbsp;
            <br />
            {/* {excelLoading ? <div style={{ textAlign: "center" }}><ClipLoader color="#4474fc" /></div> : */}
              <>
                <h5 className="">Calculation Filter Options
                  <div className="btn-tooltip" id="active_communites">
                    <IoMdInformationCircleOutline height={50} width={50} />
                    <Tooltip
                      anchorSelect="#active_communites"
                      style={{ zIndex: 999 }}
                      content={
                        <>
                          Use operators<br /> &lt;, &gt;, = , &lt;= , &gt;=, # (range),<br /> !(empty)
                        </>
                      }
                    />
                  </div>
                </h5>
                <div className="border-top">
                  {/* <div className="row">
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MONTHS OPEN:</label>
                      <input style={{ marginTop: "20px" }} value={filterQueryCalculation.months_open} name="months_open" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">LATEST LOTS RELEASED:
                        <div className="btn-tooltip" id="latest_lots_released">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#latest_lots_released"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input style={{ marginTop: "20px" }} value={filterQueryCalculation.latest_lots_released} name="latest_lots_released" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">LATEST STANDING INVENTORY:
                        <div className="btn-tooltip" id="latest_lots_released">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#latest_standing_inventory"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.latest_standing_inventory} name="latest_standing_inventory" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG SQFT ALL:
                        <div className="btn-tooltip" id="avg_sqft_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_sqft_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Average SqFt <br />of all known<br />  products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input style={{ marginTop: "20px" }} value={filterQueryCalculation.avg_sqft_all} name="avg_sqft_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG SQFT ACTIVE:
                        <div className="btn-tooltip" id="avg_sqft_active">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_sqft_active"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Average SqFt <br />of actively <br /> selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_sqft_active} name="avg_sqft_active" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG BASE PRICE ALL:
                        <div className="btn-tooltip" id="avg_base_price_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_base_price_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Average Base <br /> Price of all <br /> known products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_base_price_all} name="avg_base_price_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG BASE PRICE ACTIVE:
                        <div className="btn-tooltip" id="avg_base_price_active">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_base_price_active"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Average Base <br />Price of actively <br /> selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_base_price_active} name="avg_base_price_active" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MIN SQFT ALL:
                        <div className="btn-tooltip" id="min_sqft_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#min_sqft_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Minimum SqFt<br /> of all known <br /> products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.min_sqft_all} name="min_sqft_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-4 mb-3">
                      <label className="form-label">MIN SQFT ACTIVE:
                        <div className="btn-tooltip" id="min_sqft_active">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#min_sqft_active"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Minimum SqFt <br />of actively <br />selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.min_sqft_active} name="min_sqft_active" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MAX SQFT ALL:
                        <div className="btn-tooltip" id="max_sqft_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#max_sqft_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Maximum SqFt <br /> of all known <br /> products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.max_sqft_all} name="max_sqft_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MAX SQFT ACTIVE:
                        <div className="btn-tooltip" id="max_sqft_active">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#max_sqft_active"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Maximum SqFt<br /> of actively <br /> selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.max_sqft_active} name="max_sqft_active" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MIN BASE PRICE ALL:
                        <div className="btn-tooltip" id="min_base_price_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#min_base_price_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Minimum Base <br /> Price o all <br /> known products,
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.min_base_price_all} name="min_base_price_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MIN BASE PRICE ACTIVE:
                        <div className="btn-tooltip" id="min_sqft_active_current">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#min_sqft_active_current"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Minimum Base <br />Price of actively <br /> selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.min_sqft_active_current} name="min_sqft_active_current" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MAX BASE PRICE ALL:
                        <div className="btn-tooltip" id="max_base_price_all">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#max_base_price_all"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Maximum Base <br /> Price of all <br /> known products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.max_base_price_all} name="max_base_price_all" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MAX BASE PRICE ACTIVE:
                        <div className="btn-tooltip" id="max_sqft_active_current">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#max_sqft_active_current"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Maximum Base<br /> Price of actively <br /> selling products
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.max_sqft_active_current} name="max_sqft_active_current" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG TRAFFIC PER MONTH THIS YEAR:
                        <div className="btn-tooltip" id="avg_net_traffic_per_month_this_year">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_net_traffic_per_month_this_year"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_net_traffic_per_month_this_year} name="avg_net_traffic_per_month_this_year" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG NET SALES PER MONTH THIS YEAR:
                        <div className="btn-tooltip" id="avg_net_sales_per_month_this_year">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_net_sales_per_month_this_year"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_net_sales_per_month_this_year} name="avg_net_sales_per_month_this_year" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG CLOSINGS PER MONTH THIS YEAR:</label>
                      <input value={filterQueryCalculation.avg_closings_per_month_this_year} name="avg_closings_per_month_this_year" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG NET SALES PER MONTH SINCE OPEN:
                        <div className="btn-tooltip" id="avg_net_sales_per_month_since_open">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_net_sales_per_month_since_open"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_net_sales_per_month_since_open} name="avg_net_sales_per_month_since_open" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">AVG NET SALES PER MONTH LAST 3 MONTH:
                        <div className="btn-tooltip" id="avg_net_sales_per_month_last_three_months">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#avg_net_sales_per_month_last_three_months"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                From "Weekly <br /> Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.avg_net_sales_per_month_last_three_months} name="avg_net_sales_per_month_last_three_months" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">MONTH NET SOLD:
                        <div className="btn-tooltip" id="month_net_sold">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#month_net_sold"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Current Month,<br /> from "Weekly <br />Traffic & Sales",
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.month_net_sold} name="month_net_sold" className="form-control" onChange={handleInputChange} />
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                      <label className="form-label">YEAR NET SOLD:
                        <div className="btn-tooltip" id="year_net_sold">
                          <IoMdInformationCircleOutline height={50} width={50} />
                          <Tooltip
                            anchorSelect="#year_net_sold"
                            style={{ zIndex: 999 }}
                            content={
                              <>
                                Current Year,<br /> from "Weekly Traffic & Sales"
                              </>
                            }
                          />
                        </div>
                      </label>
                      <input value={filterQueryCalculation.year_net_sold} name="year_net_sold" className="form-control" onChange={handleInputChange} />
                    </div>
                  </div> */}

                <div className="row">
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MONTHS OPEN:</label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.months_open} name="months_open" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">LATEST LOTS RELEASED:
                      <div className="btn-tooltip" id="latest_lots_released">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#latest_lots_released"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.latest_lots_released} name="latest_lots_released" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">LATEST STANDING INVENTORY:
                      <div className="btn-tooltip" id="latest_lots_released">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#latest_standing_inventory"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.latest_standing_inventory} name="latest_standing_inventory" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG SQFT ALL:
                      <div className="btn-tooltip" id="avg_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average SqFt <br />of all known<br />  products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.avg_sqft_all} name="avg_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG SQFT ACTIVE:
                      <div className="btn-tooltip" id="avg_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average SqFt <br />of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_sqft_active} name="avg_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG BASE PRICE ALL:
                      <div className="btn-tooltip" id="avg_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average Base <br /> Price of all <br /> known products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_base_price_all} name="avg_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="avg_base_price_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_base_price_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average Base <br />Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_base_price_active} name="avg_base_price_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MIN SQFT ALL:
                      <div className="btn-tooltip" id="min_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum SqFt<br /> of all known <br /> products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_sqft_all} name="min_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-4 mb-3">
                    <label className="form-label">MIN SQFT ACTIVE:
                      <div className="btn-tooltip" id="min_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum SqFt <br />of actively <br />selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_sqft_active} name="min_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX SQFT ALL:
                      <div className="btn-tooltip" id="max_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum SqFt <br /> of all known <br /> products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_sqft_all} name="max_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX SQFT ACTIVE:
                      <div className="btn-tooltip" id="max_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum SqFt<br /> of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_sqft_active} name="max_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MIN BASE PRICE ALL:
                      <div className="btn-tooltip" id="min_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum Base <br /> Price o all <br /> known products,
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_base_price_all} name="min_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      MIN BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="min_base_price_active_tooltip">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_base_price_active_tooltip"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum Base <br />Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>

                    <input
                      value={filterQueryCalculation.min_base_price_active}
                      name="min_base_price_active"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX BASE PRICE ALL:
                      <div className="btn-tooltip" id="max_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum Base <br /> Price of all <br /> known products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_base_price_all} name="max_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">
                      MAX BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="max_base_price_active_tooltip">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_base_price_active_tooltip"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum Base<br /> Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>

                    <input
                      value={filterQueryCalculation.max_base_price_active}
                      name="max_base_price_active"
                      className="form-control"
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG TRAFFIC PER MONTH THIS YEAR:
                      <div className="btn-tooltip" id="avg_net_traffic_per_month_this_year">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_traffic_per_month_this_year"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_traffic_per_month_this_year} name="avg_net_traffic_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH THIS YEAR:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_this_year">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_this_year"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_this_year} name="avg_net_sales_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG CLOSINGS PER MONTH THIS YEAR:</label>
                    <input value={filterQueryCalculation.avg_closings_per_month_this_year} name="avg_closings_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH SINCE OPEN:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_since_open">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_since_open"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_since_open} name="avg_net_sales_per_month_since_open" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH LAST 3 MONTH:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_last_three_months">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_last_three_months"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_last_three_months} name="avg_net_sales_per_month_last_three_months" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MONTH NET SOLD:
                      <div className="btn-tooltip" id="month_net_sold">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#month_net_sold"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Current Month,<br /> from "Weekly <br />Traffic & Sales",
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.month_net_sold} name="month_net_sold" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">YEAR NET SOLD:
                      <div className="btn-tooltip" id="year_net_sold">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#year_net_sold"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Current Year,<br /> from "Weekly Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.year_net_sold} name="year_net_sold" className="form-control" onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            </>
            {/* } */}

            <br />
            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                onClick={HandleCancelFilter}
                variant="secondary"
              >
                Reset
              </Button>
              <Button
                className="btn-sm"
                onClick={HandleFilterForm}
                variant="primary"
              >
                Filter
              </Button>
            </div>
          </div>
        </div>
      </Offcanvas>

      {/* Calculation Filter */}
      {/* <Offcanvas
        show={manageCalculationFilterOffcanvas}
        onHide={setManageCalculationFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="">Calculation Filter Subdivision
            <div className="btn-tooltip" id="active_communites">
              <IoMdInformationCircleOutline height={50} width={50} />
              <Tooltip
                anchorSelect="#active_communites"
                style={{ zIndex: 999 }}
                content={
                  <>
                    Use operators<br /> &lt;, &gt;, = , &lt;= , &gt;=, # (range),<br /> !(empty)
                  </>
                }
              />
            </div>
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageCalculationFilterOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <Fragment>
              <div>
                <div className="row">
                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MONTHS OPEN:</label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.months_open} name="months_open" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">LATEST LOTS RELEASED:
                      <div className="btn-tooltip" id="latest_lots_released">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#latest_lots_released"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.latest_lots_released} name="latest_lots_released" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">LATEST STANDING INVENTORY:
                      <div className="btn-tooltip" id="latest_lots_released">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#latest_standing_inventory"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.latest_standing_inventory} name="latest_standing_inventory" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG SQFT ALL:
                      <div className="btn-tooltip" id="avg_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average SqFt <br />of all known<br />  products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input style={{ marginTop: "20px" }} value={filterQueryCalculation.avg_sqft_all} name="avg_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG SQFT ACTIVE:
                      <div className="btn-tooltip" id="avg_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average SqFt <br />of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_sqft_active} name="avg_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG BASE PRICE ALL:
                      <div className="btn-tooltip" id="avg_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average Base <br /> Price of all <br /> known products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_base_price_all} name="avg_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="avg_base_price_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_base_price_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Average Base <br />Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_base_price_active} name="avg_base_price_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MIN SQFT ALL:
                      <div className="btn-tooltip" id="min_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum SqFt<br /> of all known <br /> products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_sqft_all} name="min_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-4 mb-3">
                    <label className="form-label">MIN SQFT ACTIVE:
                      <div className="btn-tooltip" id="min_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum SqFt <br />of actively <br />selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_sqft_active} name="min_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX SQFT ALL:
                      <div className="btn-tooltip" id="max_sqft_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_sqft_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum SqFt <br /> of all known <br /> products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_sqft_all} name="max_sqft_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX SQFT ACTIVE:
                      <div className="btn-tooltip" id="max_sqft_active">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_sqft_active"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum SqFt<br /> of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_sqft_active} name="max_sqft_active" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MIN BASE PRICE ALL:
                      <div className="btn-tooltip" id="min_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum Base <br /> Price o all <br /> known products,
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_base_price_all} name="min_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MIN BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="min_sqft_active_current">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#min_sqft_active_current"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Minimum Base <br />Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.min_sqft_active_current} name="min_sqft_active_current" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX BASE PRICE ALL:
                      <div className="btn-tooltip" id="max_base_price_all">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_base_price_all"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum Base <br /> Price of all <br /> known products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_base_price_all} name="max_base_price_all" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MAX BASE PRICE ACTIVE:
                      <div className="btn-tooltip" id="max_sqft_active_current">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#max_sqft_active_current"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Maximum Base<br /> Price of actively <br /> selling products
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.max_sqft_active_current} name="max_sqft_active_current" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG TRAFFIC PER MONTH THIS YEAR:
                      <div className="btn-tooltip" id="avg_net_traffic_per_month_this_year">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_traffic_per_month_this_year"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_traffic_per_month_this_year} name="avg_net_traffic_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH THIS YEAR:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_this_year">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_this_year"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_this_year} name="avg_net_sales_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG CLOSINGS PER MONTH THIS YEAR:</label>
                    <input value={filterQueryCalculation.avg_closings_per_month_this_year} name="avg_closings_per_month_this_year" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH SINCE OPEN:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_since_open">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_since_open"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_since_open} name="avg_net_sales_per_month_since_open" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">AVG NET SALES PER MONTH LAST 3 MONTH:
                      <div className="btn-tooltip" id="avg_net_sales_per_month_last_three_months">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#avg_net_sales_per_month_last_three_months"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              From "Weekly <br /> Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.avg_net_sales_per_month_last_three_months} name="avg_net_sales_per_month_last_three_months" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">MONTH NET SOLD:
                      <div className="btn-tooltip" id="month_net_sold">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#month_net_sold"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Current Month,<br /> from "Weekly <br />Traffic & Sales",
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.month_net_sold} name="month_net_sold" className="form-control" onChange={handleInputChange} />
                  </div>

                  <div className="col-md-3 mt-3 mb-3">
                    <label className="form-label">YEAR NET SOLD:
                      <div className="btn-tooltip" id="year_net_sold">
                        <IoMdInformationCircleOutline height={50} width={50} />
                        <Tooltip
                          anchorSelect="#year_net_sold"
                          style={{ zIndex: 999 }}
                          content={
                            <>
                              Current Year,<br /> from "Weekly Traffic & Sales"
                            </>
                          }
                        />
                      </div>
                    </label>
                    <input value={filterQueryCalculation.year_net_sold} name="year_net_sold" className="form-control" onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            </Fragment>
            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                variant="secondary"
                onClick={() => {
                  setFilterQueryCalculation({
                    months_open: "",
                    latest_lots_released: "",
                    latest_standing_inventory: "",
                    avg_sqft_all: "",
                    avg_sqft_active: "",
                    avg_base_price_all: "",
                    avg_base_price_active: "",
                    min_sqft_all: "",
                    min_sqft_active: "",
                    max_sqft_all: "",
                    max_sqft_active: "",
                    min_base_price_all: "",
                    min_sqft_active_current: "",
                    max_base_price_all: "",
                    max_sqft_active_current: "",
                    avg_net_traffic_per_month_this_year: "",
                    avg_net_sales_per_month_this_year: "",
                    avg_closings_per_month_this_year: "",
                    avg_net_sales_per_month_since_open: "",
                    avg_net_sales_per_month_last_three_months: "",
                    month_net_sold: "",
                    year_net_sold: "",
                  });
                  setFilter(false);
                  GetSubdivisionList(1, sortConfig, searchQuery);
                  setManageCalculationFilterOffcanvas(false);
                }}
              >
                Reset Calculation
              </Button>
              <Button
                className="btn-sm"
                variant="primary"
                onClick={() => {
                  setFilter(true);
                  setManageCalculationFilterOffcanvas(false);
                }}
              >
                Filter Calculation
              </Button>
            </div>
          </div>
        </div>
      </Offcanvas> */}

      {/* Export */}
      <Modal show={exportmodelshow} onHide={() => setExportModelShow(true)} size="xl">
        <Fragment>
          <Modal.Header>
            <Modal.Title>Export</Modal.Title>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => { resetSelection(); setExportModelShow(false); }}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={6}>
                <ul className='list-unstyled'>
                  <li>
                    <label className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectAll}
                        onChange={handleSelectAllToggle}
                      />
                      Select All
                    </label>
                  </li>
                  {exportColumns.slice(0, 33).map((col) => (
                    <li key={col.label}>
                      <label className='form-check'>
                        <input
                          type="checkbox"
                          className='form-check-input'
                          checked={selectedColumns.includes(col.label)}
                          onChange={() => handleColumnToggle(col.label)}
                        />
                        {col.label}
                      </label>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={6}>
                <ul className='list-unstyled'>
                  {exportColumns.slice(33, 65).map((col) => (
                    <li key={col.label}>
                      <label className='form-check'>
                        <input
                          type="checkbox"
                          className='form-check-input'
                          checked={selectedColumns.includes(col.label)}
                          onChange={() => handleColumnToggle(col.label)}
                        />
                        {col.label}
                      </label>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <button 
              varient="primary" 
              className="btn btn-primary" 
              disabled={excelDownload} 
              onClick={handleDownloadExcel}
            >
              {excelDownload ? "Downloading..." : "Download"}
            </button>
          </Modal.Footer>
        </Fragment>
      </Modal>

            {/* Popup */}
            <Modal show={showPopup} onHide={HandlePopupDetailClick}>
              <Modal.Header handlePopupClose>
                <Modal.Title>Alert</Modal.Title>
                <button
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handlePopupClose()}
                ></button>
              </Modal.Header>
              <Modal.Body>{message}</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handlePopupClose}>Close</Button>
              </Modal.Footer>
            </Modal>

      <AccessField
        tableName={"subdivisions"}
        setFieldList={setFieldList}
        manageAccessField={manageAccessField}
        setManageAccessField={setManageAccessField}
      />
    </Fragment>
  );
};

export default SubdivisionList;
